export const Questions: any = [
    {
        nr: 1,
        question: '1.1. Hogyan kell kialakítani a munkahelyeket?',
        type: 'radio',
        answers: ['a munkavédelemre vonatkozó szabályokban meghatározottak, ezek hiányában a tudományos, technikai színvonal mellett elvárható követelmények megtartásával', 'a munkahelyek legyenek kényelmesek, tágasak és biztonságosak']
    }, {
        nr: 2,
        question: '1.2. Munkahelyek létesítése során mi az egyik alapvető feladat?',
        type: 'radio',
        answers: ['a létesítés során a munkavédelmi követelmények érvényre juttatása a létesítésben közreműködők feladata, amelynek teljesítésében együtt kell működniük.', 'tekintettel kell lenni a majdan ott dolgozók elvárásaira.']
    }, {
        nr: 3,
        question: '1.3. Mikor szükséges ”munkavédelmi üzembe helyezés”?',
        type: 'radio',
        answers: ['minden új munkahely, munkaeszköz, technológia üzemeltetését megelőzően', 'minden új, veszélyes munkahely, munkaeszköz, technológia üzemeltetését megelőzően']
    }, {
        nr: 4,
        question: '1.4. Mi a munkavédelmi üzembe helyezés feltétele?',
        type: 'radio',
        answers: ['a munkavédelmi szempontú előzetes vizsgálat', 'az üzembe helyezés nincs feltételekhez kötve']
    }, {
        nr: 5,
        question: '1.5 Mi a célja a munkavédelmi szempontú előzetes vizsgálatnak?',
        type: 'radio',
        answers: ['annak megállapítása, hogy a létesítmény, a munkahely, a munkaeszköz, a technológia megfelel az egészséget nem veszélyeztető és biztonságos munkavégzéshez szükséges tárgyi, személyi, szervezési, munkakörnyezeti feltételeknek', 'az előzetes vizsgálat célja az összes veszélyforrás és kockázat feltárása ami az üzemeltetés során előfordulhat']
    }, {
        nr: 6,
        question: '1.6. A munkavédelmi szempontú előzetes vizsgálatot - kivéve a veszélyes technológia esetét ki végezheti?',
        type: 'radio',
        answers: ['Az ott dolgozók közül bárki akit megbíznak', 'csak szakirányú akkreditált intézmény']
    }, {
        nr: 7,
        question: '1.7. A távmunkavégzést írásban, a munkaszerződésben kell-e a feleknek megállapodni?',
        type: 'radio',
        answers: ['nem szükséges', 'írásban, a munkaszerződésben kell megállapodni']
    }, {
        nr: 8,
        question: '1.8. Home office esetén a munkáltató a munkavédelmi szabályok megtartását akár távolról is ellenőrizheti?',
        type: 'radio',
        answers: ['igen', 'nincs szabályozva']
    }, {
        nr: 9,
        question: '1.9. Home office estén mikor dolgozzon a munkavállaló?',
        type: 'radio',
        answers: ['nincs meghatározva', 'a dolgozó köteles meghatározott időben ellátni a feladatait']
    }, {
        nr: 10,
        question: '1.10. Home office esetén a munkavállaló a munkavégzés konkrét helyszínét saját maga választhatja meg?',
        type: 'radio',
        answers: ['igen lehet az otthonán kívül is', 'kizárólag a munkáltató szabja meg a munkavégzés helyét']
    }, {
        nr: 11,
        question: '1.11. Eltérhet az üzemeltető munkáltató a MVT 21.§-tól? /21. § Az üzemeltető munkáltató a veszélyes létesítmény, munkahely, munkaeszköz, technológia üzemeltetését írásban elrendeli (a továbbiakban: munkavédelmi üzembe helyezés)/',
        type: 'radio',
        answers: ['nem', 'igen, belső szabályzatában szigoríthatja']
    }, {
        nr: 12,
        question: '1.12. Mit nevezünk magasban levő ideiglenesen végzett munkának?',
        type: 'radio',
        answers: ['az 1 méternél nagyobb szintkülönbségen végzett, nem állandó jellegű, rövid ideig tartó munka, ahol a biztonsági és ergonómiai követelményeknek megfelelő munkahelyi körülmények nem biztosítottak, ezért egyedi kockázatmegelőző intézkedések megtétele szükséges', 'ha a munkahelyen a munkavállaló mindkét talpa 1 méter feletti magasságba kerül']
    }, {
        nr: 13,
        question: '1.13. Mely esetekben kell a munkavállalót a munkaeszközök használatáról kioktatni?',
        type: 'radio',
        answers: ['elegendő csak munkába álláskor', 'a munkavállalót munkába álláskor, a munkaeszköz átalakításakor, új munkaeszköz használatba vételekor vagy üzembe helyezésekor kell kioktatni']
    }, {
        nr: 14,
        question: '1.14. Szükséges a munkavédelmi oktatásokat dokumentálni?',
        type: 'radio',
        answers: ['igen, így igazolható, hogy az oktatás megtörtént', 'nem']
    }, {
        nr: 15,
        question: '1.15. Hogyan kell a munkavégzés kockázatait a minimális szintre csökkenteni?',
        type: 'radio',
        answers: ['időben korlátozni kell a munkavégzést', 'zárt technológia alkalmazásával, ha ez nem oldható meg, akkor kollektív műszaki védelem, szervezési intézkedések, egyéni védőeszközök - szükség szerinti együttes – alkalmazásával']
    }, {
        nr: 16,
        question: '1.16. Mikor kerülhet sor magasban ideiglenes munkavégzésre?',
        type: 'radio',
        answers: ['csak nappali műszakban, amikor minden jól látható', 'magasban ideiglenes munkavégzésre csak akkor kerülhet sor, ha az időjárási feltételek a munkavállaló egészségét és biztonságát nem veszélyeztetik']
    }, {
        nr: 17,
        question: '1.17. Egyéni védőeszközök tekintetében mely szervezeteket nevezünk gazdasági szereplőknek?',
        type: 'radio',
        answers: ['gyártó, meghatalmazott képviselő, importőr, forgalmazó', 'gyártó, meghatalmazott képviselő, importőr, forgalmazó, felhasználó']
    }, {
        nr: 18,
        question: '1.18. Az egyéni védőeszközök forgalmazásának tekintetében mire kell törekedniük a gazdasági szereplőknek?',
        type: 'radio',
        answers: ['arra, hogy a védőeszköz minél olcsóbb legyen', 'arra, hogy a védőeszköz teljes dokumentációja könnyen érthető legyen és tartalmazza a naprakész információkat']
    }, {
        nr: 19,
        question: '1.19 Mennyi az EU típusvizsgálati tanúsítvány maximális érvényességi ideje?',
        type: 'radio',
        answers: ['maximum 5 év', 'a termék védelmi szintjétől függ']
    }, {
        nr: 20,
        question: '1.20. Mit nevezünk bejelentett szervezetnek?',
        type: 'radio',
        answers: ['amely az egyéni védőeszköz megfelelőségét tanúsítja, és az eszközt ellenőrizheti', 'amely a nemzeti munkavédelmi hatóságnak bejelenti, hogy egyéni védőeszközt gyárt']
    }, {
        nr: 21,
        question: '1.21. A védőeszközök mi szerint vannak kategorizálva?',
        type: 'radio',
        answers: ['védelmi szintjük szerint', 'fejvédelem, testvédelem, lábvédelem, légzésvédelem, leesés elleni védelem']
    }, {
        nr: 22,
        question: '1.22. A védőeszközöket hogyan sorolják be?',
        type: 'radio',
        answers: ['nincs ilyen felosztás', 'három kategóriába sorolják']
    }, {
        nr: 23,
        question: '1.23. Mely kategóriába sorolják a leesés, zuhanás ellen védő eszközöket?',
        type: 'radio',
        answers: ['2. kategóriába', '3. kategóriába']
    }, {
        nr: 24,
        question: '1.24. Mely kategóriába sorolják a villamosság által okozható kockázati tényezők ellen védő eszközöket?',
        type: 'radio',
        answers: ['2. kategóriába', '3. kategóriába']
    }, {
        nr: 25,
        question: '1.25. Ki jelöli ki az egyéni védőeszközök megfelelőségét értékelő szervezeteket?',
        type: 'radio',
        answers: ['a foglalkoztatáspolitikáért felelős miniszter', 'a Nemzeti Akkreditáló Hatóság']
    }, {
        nr: 26,
        question: '1.26. Milyen gyakorisággal kell elvégezni a leesés elleni eszközök (pl. teljes testheveder, rögzítő kötelek, mentőeszközök, mászó szerszám) időszakos biztonsági felülvizsgálatát?',
        type: 'radio',
        answers: ['a gyártó előírása szerint', 'az MSZ 1585 szerint félévente']
    }, {
        nr: 27,
        question: '1.27. A hordozható kisgépek vagy kézben tartott elektromos kéziszerszámok elektromos érintésvédelmi vizsgálatát mikor kell elvégezni?',
        type: 'radio',
        answers: ['a vizsgálat ideje nincs megszabva', 'évente kötelező elvégezni']
    }, {
        nr: 28,
        question: '1.28. Milyen gyakorisággal kell elvégezni a feszültségkémlelők, szigetelő- vagy kezelő rudak időszakos biztonsági felülvizsgálatát?',
        type: 'radio',
        answers: ['a gyártó előírása szerint', 'az MSZ 1585 szerint 2 évente']
    }, {
        nr: 29,
        question: '1.29. Ha a munkavégzés során az MSZ 1585-ben nem szereplő egyéni-, ill. villamos biztonsági eszköz használnak, milyen gyakorisággal kell az időszakos biztonsági felülvizsgálatot elvégezni?',
        type: 'radio',
        answers: ['évente', 'a vonatkozó jogszabály vagy a termékszabvány előírásai szerint kell eljárni ']
    }, {
        nr: 30,
        question: '1.30. Vírus terjedés esetén köteles-e a munkáltató megelőző intézkedéseket megtenni?',
        type: 'radio',
        answers: ['nincs jogszabályban előírva', 'köteles a vírus terjedésének lassításában, megállításában intézkedést tenni']
    }, {
        nr: 31,
        question: '1.31. Hogyan és kinek kell az egyéni védőeszköz juttatás belső rendjét meghatározni?',
        type: 'radio',
        answers: ['a jutatási rend kialakítása a munkáltató feladata, a juttatási rend kialakításába munkabiztonsági és munkaügyi szaktevékenységre jogosult személyt kell bevonni, a juttatási rendet írásban kell rögzíteni', 'a juttatási rend kialakítása a munkavédelmi érdekképviselők feladata']
    }, {
        nr: 32,
        question: '1.32. Hogyan kell az egyéni védőeszközöket meghatározni, kiválasztani?',
        type: 'radio',
        answers: ['a forgalmazók katalógusaiból', 'a folyamatba javasolt valamennyi érdekelt felet (munkáltató, munka-, és foglalkozás egészségügyi szakember, munkavállalók képviselője, munkavédelmi érdekképviselő, egyéb szakértők, beszerzők stb.) bevonni']
    }, {
        nr: 33,
        question: '2.1.Melyik jogszabály szabályozza a munkabaleset fogalmát, kivizsgálását, nyilvántartását és a bejelentés szabályait?',
        type: 'radio',
        answers: ['A Munkavédelmi törvény (1993. évi XCIII. törvény 64. §)', 'A munka törvénykönyve (2012. évi I. tör.)']
    }, {
        nr: 34,
        question: '2.2. Melyik baleset tekinthető munkabalesetnek?',
        type: 'radio',
        answers: ['Az a baleset, amely a munkavállalót a szervezett munkavégzés során vagy azzal összefüggésben éri.', 'Az a baleset, amely egyéb (pl.társadalmi) munkavégzés során következik be.']
    }, {
        nr: 35,
        question: '2.3. Munkabalesetnek tekinthető, ha a munkavállaló a munkaidejében az üzemi étkezéskor megcsúszik, elesik és megsérül?',
        type: 'radio',
        answers: ['Igen mert szervezett munkavégzéshez kapcsolódóan vagy azzal összefüggésben éri.', 'nem']
    }, {
        nr: 36,
        question: '2.4. Munkabalesetnek tekinthető, ha a munkavállaló munkaidejében a munkáltató saját vagy bérelt járművével történik közúti baleset?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 37,
        question: '2.5. A munkáltató telephelyén lévő sportpályán munkaidő után történt sportsérülés munkabaleset lesz-e?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 38,
        question: '2.6. A munkavállaló munkába jövet és hazafelé menet történő balesete munkabalesetnek tekinthető-e?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 39,
        question: '2.7. Az úti balesetek esetén vizsgálni kell, hogy a dolgozó balesete a munkahely és a lakása közötti legrövidebb úton történt, illetve hosszabb időre megszakította az útját?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 40,
        question: '2.8. Nagyobb kitérésnek minősül az, ha a hazafelé tartó úton a dolgozó legelemibb életszükségleteinek kielégítése végett (például a napi élelmiszer vásárlás, gyógyszer beszerzése, továbbá a gyermek bölcsődéből, óvodából, iskolából való hazavitele céljából) történt a megszakítás.',
        type: 'radio',
        answers: ['A napi élelmiszer vásárlás, gyógyszer beszerzése, továbbá a gyermek bölcsődéből, óvodából, iskolából való hazavitele céljából történt a megszakítás nagyobb kitérésnek minősül.', 'A napi élelmiszer vásárlás, gyógyszer beszerzése, továbbá a gyermek bölcsődéből, óvodából, iskolából való hazavitele céljából történt a megszakítás nem minősül nagyobb kitérésnek.']
    }, {
        nr: 41,
        question: '2.9. Súlyos munkabaleset esetén a foglalkozás-egészségügyi alapszolgáltatást biztosító szolgálat orvosának rész kell venni a kivizsgálásban?',
        type: 'radio',
        answers: ['Igen a kivizsgálás megkezdéséről a szolgálat orvosát tájékoztatni kell. Az orvosnak részt kell venni a kivizsgálásba.', 'A kivizsgálásban történő orvosi közreműködésről az orvos dönti el, hogy részt kíván venni.']
    }, {
        nr: 42,
        question: '2.10. Kvázi baleset (majdnem baleset) kivizsgálását úgy kell elvégezni mintha valamilyen sérüléssel járt volna?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 43,
        question: '2.11. Kvázi baleset (majdnem baleset) esetén a hasonló esetekre megfelelő megelőző intézkedéseket kell hozni. Ok-okozati összefüggéseket fel kell tárni?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 44,
        question: '2.12. A munkavégzés, a foglalkozás gyakorlása közben bekövetkezett olyan heveny vagy idült, valamint a foglalkozás gyakorlását követően megjelenő vagy kialakuló egészségkárosodás, munkabalesetnek tekinthető?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 45,
        question: '2.13. Foglalkozási megbetegedésnek tekinthető, amely a munkavállaló az optimálisnál nagyobb vagy kisebb igénybevételének a következménye?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 46,
        question: '2.14. A munkáltatónak meg kell térítenie az üzemi baleset vagy foglalkozási megbetegedések miatt felmerült egészség-biztosítási ellátást, ha a baleset vagy megbetegedés annak a következménye, hogy ő vagy megbízottja a reá nézve kötelező munkavédelmi szabályokban foglalt kötelezettségének nem tett eleget.',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 47,
        question: '2.15. A munkanapkiesést nem eredményező munkabalesetet elég csak „tisztázni” és nem kell „kivizsgálni”.',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 48,
        question: '2.16. Az 1-3 napos a munkaképtelenség esetén munkabaleseti jegyzőkönyvet kell kiállítani és nyilvántartásba kell venni?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 49,
        question: '2.17. A súlyos munkabalesetet a munkáltatónak – telefonon, telefaxon, e-mailben vagy személyesen – haladéktalanul hová és kinek kell bejelenteni a rendelkezésre álló adatok közlésével?',
        type: 'radio',
        answers: ['A bejegyzett telephely szerinti fővárosi, illetve megyei munkavédelmi hatóságnak.', 'A munkabaleset helyszíne szerint illetékes fővárosi, illetve megyei munkavédelmi hatóság felé.']
    }, {
        nr: 50,
        question: '2.18. Olyan munkahelyen, ahol különböző munkáltatók munkavállalókat egyidejűleg foglalkoztatnak súlyos munkabaleset bejelentési kötelezettsége kinek a feladata?',
        type: 'radio',
        answers: ['Az ott dolgozók közül bárki megteheti.', 'Ha a munkáltató személye nem állapítható meg, akkor a munkáltatónak azt kell tekinteni, akinek a területén a munkavégzés folyik.']
    }, {
        nr: 51,
        question: '2.19. Súlyos munkabalesetet ki vizsgálhatja ki?',
        type: 'radio',
        answers: ['A súlyos munkabaleset kivizsgálása munkabiztonsági és foglalkozás-egészségügyi szaktevékenység.', 'A kivizsgálást a munkahely munkavédelemmel megbízottja a munkavédelmi képviselővel együtt végzi.']
    }, {
        nr: 52,
        question: '2.20. A balesetet észlelő személy köteles a balesetet a munkát közvetlenül irányító személynek haladéktalanul jelenteni?',
        type: 'radio',
        answers: ['A sérült, illetőleg a balesetet észlelő személy köteles azonnal a balesetet a munkát közvetlenül irányító személynek haladéktalanul jelenteni.', 'Ha sérült neki felróható okból nem jelenti a sérülést, akkor a sérültet terheli annak bizonyítása, hogy a baleset a munkavégzés során vagy azzal összefüggésben történt.']
    }, {
        nr: 53,
        question: '2.21. A munkáltatónak minden bejelentett, illetve tudomására jutott balesetről meg kell állapítania, hogy azt munkabalesetnek tekinti?',
        type: 'radio',
        answers: ['A munkáltató kivizsgálás során nyert adatok alapján állapítja meg, hogy a baleset munkabaleset.', 'Ha a sérült nem jelentette a sérülést munkáltató felé, akkor később neki kell bizonyítani a sérülés körülményeit.']
    }, {
        nr: 54,
        question: '2.22. Ha a munkáltató a munkahelyen történt balesetet nem tekinti munkabalesetnek, akkor…',
        type: 'radio',
        answers: ['Nem indokolja a döntését és nem ad jogorvoslati lehetőséget.', 'A jogorvoslat lehetőségéről a sérültet, halálos baleset esetén a hozzátartozót értesítenie kell.']
    }, {
        nr: 55,
        question: '1.23. A munkáltatónak lehetővé kell tenni a munkavédelmi képviselő részvételét a munkabaleset kivizsgálásában.',
        type: 'radio',
        answers: ['Igen mert a Mvt. kötelezi.', 'Nem, mert a képviselőt a munkáltató nem köteles értesíteni a kivizsgálás megkezdéséről.']
    }, {
        nr: 56,
        question: '2.24. A munkabaleset bekövetkezésétől számítva a munkáltató a törvényben foglaltak alapján meddig köteles a munkabalesetet bejelenteni, kivizsgálni és nyilvántartásba venni?',
        type: 'radio',
        answers: ['A munkabaleset bejelentése, kivizsgálása és nyilvántartásba vétele nincs időhatárhoz kötve.', '3 év után a munkáltató nem köteles a munkabalesetet bejelenteni, kivizsgálni és nyilvántartásba venni.']
    }, {
        nr: 57,
        question: '2.25. A munkáltató kötelessége, hogy a bekövetkezett balesetekről tájékoztassa a munkavédelmi képviselőt?',
        type: 'radio',
        answers: ['igen', 'nem']
    }, {
        nr: 58,
        question: '2.26. A munkavédelmi képviselő köteles részt venni a munkabaleset kivizsgálásban?',
        type: 'radio',
        answers: ['igen', 'A munkavédelmi képviselő dönti el, hogy részt kíván-e venni a kivizsgálásban, vagy csak az iratokat kéri be.']
    }, {
        nr: 59,
        question: '2.27. A munkabaleset kivizsgálását végezheti a munkavédelmi képviselő?',
        type: 'radio',
        answers: ['Igen jogosult, mert bizonyított, hogy munkavédelmi képviselői alapoktatásban részesült.', 'Nem mert kivizsgálás a munkáltató és a munkavédelmi szakember dolga, ezt nem veheti át a képviselő.']
    }, {
        nr: 60,
        question: '2.28. A munkavédelmi képviselő hogyan vehet részt a baleset kivizsgálásában?',
        type: 'radio',
        answers: ['Csak megfigyelőként vehet részt és csak a munkabaleseti jegyzőkönyvet írja alá.', 'A képviselő a vizsgálat során maga is kérdezhet a sérülttől, a tanuktól, a munkahelyi vezetőktől, a kivizsgálótól is. Vizsgálati szempontokra is tehet javaslatot.']
    }, {
        nr: 61,
        question: '2.29. A munkavédelmi képviselő a munkabaleseti jegyzőkönyvet aláírásával hitelesíti. Ha nem ért egyet a jegyzőkönyvben leírtakkal…',
        type: 'radio',
        answers: ['Nem írja alá a jegyzőkönyvet.', 'Aláírja és leírhatja az eltérő véleményét egy külön lapon.']
    }, {
        nr: 62,
        question: '2.30. A munkáltató köteles-e kártérítést nyújtani a munkavállalónak a munkahelyen bekövetkezett munkabaleset után anyagi, dologi és egyéb költségi károkért?',
        type: 'radio',
        answers: ['Igen mert a kártérítést az Mt. (2012. évi I. tör.) szabályozza', 'Nem mert a kárigényt a felelősség biztosítótól kell igényelni a sérültnek.']
    }, {
        nr: 63,
        question: '3.1. Melyik jogszabály határozza meg a foglalkozási megbetegedés fogalmát?',
        type: 'radio',
        answers: ['A munka törvénykönyve.', 'A munkavédelmi törvény 87. § 1/D. pontja egybevágóan a 27/1996. (VIII. 28.) NM rendelet 2.§ a) pontjával.']
    }, {
        nr: 64,
        question: '3.2. 1993. évi XCIII. törvény milyen nyilvántartási kötelezettséget határoz meg a veszélyes anyagok és a rákkeltő vagy mutogén anyagok tekintetében.',
        type: 'radio',
        answers: ['A törvény két külön nyilvántartási kötelezettséget és egy bejelentési kötelezettséget nevesít.', 'Nem részletezi a külön a veszélyes anyagok és a rákkeltő vagy mutogén anyagok tekintetében.']
    }, {
        nr: 65,
        question: '3.3. A veszélyes anyagoknak expozíció esetén a nyilvántartás adatait a munkaviszony megszűnését követő hány évig kell nyilvántartani',
        type: 'radio',
        answers: ['10 évig, ha a munkavállaló rákkeltő hatású anyagnak van kitéve', '5 évig, ha pedig a munkavállaló rákkeltő hatású anyagnak van kitéve']
    }, {
        nr: 66,
        question: '3.4. Ha a munkavállaló rákkeltő hatású anyagnak van kitéve, a nyilvántartás adatait a munkaviszony megszűnését követő hány évig kell nyilvántartani',
        type: 'radio',
        answers: ['50 évig', '25 évig']
    }, {
        nr: 67,
        question: '3.5. Fokozott expozíciós eset kivizsgálását és a kockázatértékelés elvégzését ki végezheti?',
        type: 'radio',
        answers: ['a munkáltató által kinevezett bizottság', 'munkaegészségügyi és munkabiztonsági szaktevékenység']
    }, {
        nr: 68,
        question: '3.6. A munkabaleset kivizsgálásában a foglalkozás-egészségügyi alapszolgáltatást biztosító szolgálat orvosának részt kell venni?',
        type: 'radio',
        answers: ['nem kell', 'csak tájékoztatni kell']
    }, {
        nr: 69,
        question: '3.7. Súlyos munkabaleset és fokozott expozíció esetén a foglalkozás-egészségügyi alapszolgáltatást biztosító szolgálat orvosának részt kell-e venni a kivizsgálásban?',
        type: 'radio',
        answers: ['csak tájékoztatni kell', 'részt kell venni a kivizsgálásban']
    }, {
        nr: 70,
        question: '3.8. Ki jelentheti be a foglalkozási megbetegedést vagy annak gyanúját?',
        type: 'radio',
        answers: ['kizárólag a foglalkozás-egészségügyi alapszolgálat orvosa', 'bármely orvosi gyakorlatot folytató orvos.']
    }, {
        nr: 71,
        question: '3.9. A foglalkozási megbetegedést (vagy annak gyanúját), illetve a fokozott expozíciós eseteket melyik hatósághoz köteles bejelenteni az első észlelő, orvosi gyakorlatot folytató orvos?',
        type: 'radio',
        answers: ['a munkáltató telephelye szerint illetékes munkavédelmi hatósághoz', 'az ÁNTSZ-hez.']
    }, {
        nr: 72,
        question: '3.10. Melyik hatóság veszi nyilvántartásba és vizsgálja ki a bejelentett foglalkozási megbetegedést?',
        type: 'radio',
        answers: ['a kormányhivatal népegészségügyi hatósága', '(a fővárosi és megyei kormányhivatal járási hivatala) munkavédelmi hatósága.']
    }, {
        nr: 73,
        question: '3.11. Melyik szakmai szerv (intézet) illetékes a foglalkozási betegség bejelentésének teljeskörűségét és szakmai megalapozottságát elbírálni és a betegség foglalkozási betegségként történő elfogadásáról értesíteni a munkavédelmi hatóságot?',
        type: 'radio',
        answers: ['az egészségbiztosítási pénztár feladatkörében eljáró hivatal', 'a Nemzeti Népegészségügyi Központ Országos Munkahigiénés és Foglalkozás-egészségügyi Főosztálya.']
    }, {
        nr: 74,
        question: '3.12. A munkavédelmi hatóság a munkáltató részéről kiket von be a foglalkozási megbetegedés kivizsgálásába?',
        type: 'radio',
        answers: ['a munkahelyi szakszervezet és az üzemi tanács képviselőjét', 'a munkáltató megbízottját (általában a munkavédelemért felelős személyt) és a működési körében illetékes munkavédelmi képviselőt.']
    }, {
        nr: 75,
        question: '3.13. A foglalkozási megbetegedés klinikai igazolása mellett milyen vizsgálatokra van szükség?',
        type: 'radio',
        answers: ['a munkahigiénés diagnózis miatt munkakörnyezeti vizsgálatokra is', 'elegendő csak a laborvizsgálatok elvégzése.']
    }, {
        nr: 76,
        question: '3.14. Mit jelent a munkahelyi monitorozás a munkavédelemben?',
        type: 'radio',
        answers: ['munkakörnyezeti (pl. a zaj) és biológiai (pl. a vérólom) monitor vizsgálatokat', 'az egészségi és munkaköri alkalmasság vizsgálatát és elbírálását.']
    }, {
        nr: 77,
        question: '3.15. A munkahelyi (szervetlen) porok a munkakörnyezeti kóroki tényezők melyik csoportjába tartoznak?',
        type: 'radio',
        answers: ['a fizikai kóroki tényezők körébe', 'a kémiai kóroki tényezők körébe (ásványi tulajdonságuk és az abszorbeált vegyi anyagok hatásai miatt).']
    }, {
        nr: 78,
        question: '3.16. A mesterséges elektromágneses terek (az elektromosság, a mikrohullámú és a rádiófrekvenciás sugárzás miatti elektromos és mágneses terek) milyen sugárexpozíciót jelentenek a munkavállalók számára?',
        type: 'radio',
        answers: ['ionizáló sugárexpozíciót', 'nem ionizáló sugárexpozíciót.']
    }, {
        nr: 79,
        question: '3.17. Melyik alkalmassági vizsgálat szolgálja leginkább a foglalkozási megbetegedések felderítését?',
        type: 'radio',
        answers: ['a gépjárművezetők és a gépkezelők egészségi alkalmassági vizsgálata', 'a munkaköri alkalmassági vizsgálatok közül főként az időszakos munkaköri alkalmassági vizsgálatok (beleértve egyes vegyi expozíciók miatti BEM/BHM, valamint a zajexpozíció és rezgésexpozíció esetén végzett vizsgálatokat is).']
    }, {
        nr: 80,
        question: '3.18. Munkahelyi zajterhelés esetén mikor beszélünk fokozott zajexpozícióról?',
        type: 'radio',
        answers: ['4000 Hz-en mért 30 dB halláscsökkenés esetén bármely fülön', '4000 Hz-en mért 50 dB és 2000 Hz-en mért 30 dB halláscsökkenés esetén.']
    }, {
        nr: 81,
        question: '3.19. A foglalkozási megbetegedések rekonstruálásához a fizikális, labor, képalkotói vizsgálatok mellett még milyen vizsgálatokra és eljárásokra van/lehet szükség?',
        type: 'radio',
        answers: ['allergia vizsgálatokra', 'a foglalkozási kórelőzmény és az expozíciós viszonyok feltárására, a megterhelés jellemzőinek a meghatározására, helyszíni ellenőrzésekre és (esetenként) munkahelyi vizsgálatokra és mérésekre is.']
    }, {
        nr: 82,
        question: '3.20. Az alábbiak közül melyik foglalkozási megbetegedés minősül bonyolult esetnek?',
        type: 'radio',
        answers: ['ha munkahelyi levegő mintavételére, méréseire, laboratóriumi vizsgálatokra is szükség van, amibe az érintett munkavállaló(ka)t is be kell vonni', 'ha nem található vagy jogutód nélkül megszűnt a munkáltató, ahol a foglalkozási megbetegedés keletkezet.']
    }, {
        nr: 83,
        question: '3.21. Milyen betegség típusnak minősül a fokozott expozíció?',
        type: 'radio',
        answers: ['veszélyes vegyi anyagok által kiváltott enyhe mérgezésnek', 'nem minősül betegségnek, a munkavállaló szervezetében meghatározott biológiai határértéket meghaladó vegyi anyag koncentrációt (mértéket) jelenti, illetve zaj esetén a várható halláscsökkenésre hívja fel a figyelmet.']
    }, {
        nr: 84,
        question: '3.22. A BEM (biológiai expozíciós mutatók) és BHM (biológiai hatás mutatók) vizsgálatokat általában milyen biológiai mintából végzik?',
        type: 'radio',
        answers: ['vizeletből és vérből', 'nyálból, verejtékből, székletből.']
    }, {
        nr: 85,
        question: '3.23. A munkakörnyezeti vagy a biológiai monitor az elsődleges a munkahelyen?',
        type: 'radio',
        answers: ['a biológiai monitor a bőrön keresztül is felszívódó vegyi anyagok miatt', 'egyik sem, mind a kétféle monitorozást alkalmazni kell, mivel egymás kiegészítésére és nem egymás helyettesítésére szolgálnak.']
    }, {
        nr: 86,
        question: '3.24. A munkahelyi monitorozás mellett mi szolgálhatja elsősorban a foglalkozás megbetegedések kialakulásának megakadályozását?',
        type: 'radio',
        answers: ['a munkaidő csökkentése', 'az időszakos munkaköri alkalmassági vizsgálatok gyakoribb elvégzése, a soron kívüli munkahelyi ellenőrzés és a soron kívüli kockázatértékelés elrendelése.']
    }, {
        nr: 87,
        question: '3.25. A foglalkozással összefüggő betegségek (work-relatad diseases - WRDs) kialakulását mi idézheti elő?',
        type: 'radio',
        answers: ['kizárólag a foglalkozás hatásai', 'a foglalkozás hatásai (mint egy tényező a sok közül) mellett az életmód, az egyéni érzékenység, a szociális körülmények, a képzettség és egyéb tényezők is szerepet játszhatnak.']
    }, {
        nr: 88,
        question: '3.26. A foglalkozási betegségek kivizsgálásának elmulasztását sérelmezheti-e a munkavállaló?',
        type: 'radio',
        answers: ['igen, a munkavédelmi törvény 68. § alapján az 1. számú melléklet szerinti bejelentő lap (nyomtatvány) útján a területileg illetékes munkavédelmi hatósághoz fordulhat', 'nem, nincs jogorvoslati lehetőség.']
    }, {
        nr: 89,
        question: '3.27. A munkavédelmi hatóság mely esetekben jogosult az ellenőrzött munkáltatónál foglalkoztatott munkavállalót eltiltani a kifogásolt munkavégzéstől?',
        type: 'radio',
        answers: ['a munkavédelmi előírások súlyos megszegése esetén', 'minden olyan esetben, amikor az ellenőrzött munkáltatót kötelezni kell a feltárt hiányosságok megszüntetésére']
    }, {
        nr: 90,
        question: '3.28. Minek a működését és használatát függesztheti fel a munkavédelmi hatóság a foglalkozási egészség veszélyeztetése miatt?',
        type: 'radio',
        answers: ['nem megfelelő védelem esetén a veszélyes tevékenységet, illetve az üzem, üzemrész működését, valamint a munkaeszköz, az egyéni védőeszköz, a veszélyes anyag vagy keverék használatát', 'az összehangolás elmulasztása miatt előírhatja az üzem bezárását.']
    }, {
        nr: 91,
        question: '3.29. Részt vehet-e a munkavédelmi képviselő működési körében a foglalkozási megbetegedés (fokozott expozíciós eset) ok-okozati összefüggéseinek feltárásában és ezzel kapcsolatban kérhet-e tájékoztatást a foglalkozás-egészségügyi szolgálattól, kifejthet-e véleményét a munkavédelmi hatóságnak?',
        type: 'radio',
        answers: ['igen, az egészségügyi és a hozzájuk tartozó adatok védelmére vonatkozó előírások (titoktartás) figyelembe vétele mellett', 'általában nem, csak ha a munkáltató engedélyezi.']
    }, {
        nr: 92,
        question: '3.30. Tudja-e, hogy a zoonózisok milyen betegségcsoportot jelentenek?',
        type: 'radio',
        answers: ['állatról emberre terjedő betegségeket, amelyek egyes foglalkozásokban is előfordulhatnak', 'növények és állatok betegségeit.']
    }, {
        nr: 93,
        question: '4.1. Mit nevezünk prevenciónak?',
        type: 'radio',
        answers: ['a prevenció a munkabalesetek és foglalkozási ártalmak megelőzését célzó intézkedések összessége', 'a foglalkozás egészségügyi szolgálat által ellátott feladatokat nevezzük prevenciónak']
    }, {
        nr: 94,
        question: '4.2. Mikor kezdődik el a prevenció?',
        type: 'radio',
        answers: ['az előzetes orvosi vizsgálat a prevenció első lépése', 'a prevenció a munkaviszony létesítése előtt, még az új munkatárs kiválasztási folyamata során elkezdődik']
    }, {
        nr: 95,
        question: '4.3. Milyen munkával bízható meg a munkavállaló?',
        type: 'radio',
        answers: ['minden olyan feladattal, amiről írásban nyilatkozik, hogy ért hozzá', 'munkavállaló csak olyan munkával bízható meg, amelynek ellátására egészségileg alkalmas, rendelkezik az egészséget nem veszélyeztető és biztonságos munkavégzéshez szükséges ismeretekkel, készséggel és jártassággal.']
    }, {
        nr: 96,
        question: '4.4. Milyen feltételekkel lehet olyan munkahelyen dolgozni, ahol veszély fenyeget?',
        type: 'radio',
        answers: ['abban az esetben, ha a munkavállalót a veszélyekre kioktattuk, és nyilatkozik, hogy alkalmasnak érzi magát a feladat ellátására', 'ahol veszély fenyeget, egyedül munkát végezni nem szabad, és ilyen helyre csak erre is kiterjedő oktatásban részesült munkavállalók léphetnek be.']
    }, {
        nr: 97,
        question: '4.5. Mi a teendő akkor, ha egy munkát egyidejűleg két, vagy több munkavállaló végez?',
        type: 'radio',
        answers: ['a legmagasabb iskolai végzettségű, vagy a legidősebb munkatársat kell kijelölni munkavezetőnek', 'ha valamely munkát egyidejűleg két vagy több munkavállaló végez, a biztonságos munkavégzés érdekében az egyik munkavállalót meg kell bízni a munka irányításával, és ezt a többiek tudomására kell hozni']
    }, {
        nr: 98,
        question: '4.6. Mit nevezünk munkaköri alkalmassági vizsgálatnak?',
        type: 'radio',
        answers: ['annak megállapítása, hogy egy meghatározott munkakörben és munkahelyen végzett tevékenység által okozott megterhelés a vizsgált személy számára milyen igénybevételt jelent és annak képes-e megfelelni;', 'annak megállapítása, hogy a munkatárs tud e megfelelős minőségű munkát végezni']
    }, {
        nr: 99,
        question: '4.7. Mit nevezünk szakmai alkalmassági vizsgálatnak?',
        type: 'radio',
        answers: ['a szakma elsajátításának megkezdését megelőző, illetőleg a képzés és az átképzés időszakában az alkalmasság véleményezése érdekében végzett orvosi vizsgálat;', 'a szakma elsajátítása után, az adott munkakörre vonatkozó alkalmasság vizsgálata']
    }, {
        nr: 100,
        question: '4.8. Milyen kategóriái vannak a munkaköri és a szakmai orvosi alkalmassági vizsgálatoknak?',
        type: 'radio',
        answers: ['előzetes, időszakos és soron kívüli, mely külön meghatározott esetekben záró vizsgálattal egészül ki', 'az orvosi alkalmassági vizsgálatoknak két kategóriája van: beosztott munkatársak és munkairányítók vizsgálatai']
    }, {
        nr: 101,
        question: '4.9. Mely esetekben szükséges előzetes szakmai alkalmassági vizsgálat?',
        type: 'radio',
        answers: ['az MSZ 1585-ben vonatkozó fejezetében besorolt személyek esetében', 'a szakképzési évfolyamra történő felvétel, átvétel, illetve továbbhaladás előtt minden olyan esetben, amikor az Országos Képzési Jegyzék szerint a szakképesítés megszerzése szakmai alkalmassági követelményekhez kötött; az iparágban tipikusan ilyen pl. FAM képzések rendszere']
    }, {
        nr: 102,
        question: '4.10. Ki kezdeményezheti a soron kívüli alkalmassági vizsgálatot?',
        type: 'radio',
        answers: ['kizárólag a foglalkozás-egészségügyi orvos', 'a foglalkozás egészségügyi orvos, a háziorvos, a kezelőorvos, a munkavédelmi és munkaügyi hatóság, a munkáltató, a munkavállaló']
    }, {
        nr: 103,
        question: '4.11. Hogyan rendelkezik a Munkavédelmi Törvény a kockázatértékelésre vonatkozóan?',
        type: 'radio',
        answers: ['A MVT 54 § (9) szerint A munkáltató a kockázatértékelést követően, annak megállapításait figyelembe véve, a feltárt kockázatok kezelése során határozza meg a védekezés leghatékonyabb módját, a kollektív, műszaki egyéni védelem módozatait, illetve az alkalmazandó szervezési és egészségügyi megelőzési intézkedéseket.', 'minden munkafolyamat esetében meg kell vizsgálni a dolgozók veszélyeztetettségét']
    }, {
        nr: 104,
        question: '4.12. Hogyan kell a kockázatértékelést elvégezni?',
        type: 'radio',
        answers: ['külön jogszabály alapján, minden munkáltatónak egység tartalommal kell elkészítenie', 'nincs külön jogszabályban előírt módszer, a Munkavédelem / Foglalkoztatás felügyelet honlapján található „Segédlet” ad gyakorlati útmutatást']
    }, {
        nr: 105,
        question: '4.13. Melyek a kockázatértékelés lépései?',
        type: 'radio',
        answers: ['A kockázatértékelés lépései - Minden munkatárs megkérdezése a munkahelyi körülményekről - A veszélyt csökkentő ötletek összegyűjtése - A veszélycsökkentő intézkedések bevezetése', 'A kockázatértékelés lépései - A veszélyeknek, kockázatoknak kitettek körének azonosítása - A kockázatok értékelése, rangsorolása - Megelőző intézkedések kidolgozása - A megelőző intézkedések bevezetése - Az intézkedések hatásosságának „visszamérése”, korrekció']
    }, {
        nr: 106,
        question: '4.14. Milyen gyakorisággal kell a kockázatértékelést elvégezni?',
        type: 'radio',
        answers: ['évente', 'a kockázatértékelést a munkakörülmények megváltozása esetén kell elvégezni, ill. rendszeresen felül kell vizsgálni']
    }, {
        nr: 107,
        question: '4.15. Miért szükséges a munkatársak a kockázatértékelés eredményéről, és a megelőző intézkedésekről tájékoztatni?',
        type: 'radio',
        answers: ['a munkáltatónak a tájékoztatás törvényben rögzített kötelessége, fontos, hogy a munkatársak ismerjék a munkahely és a munkafolyamat során jelentkező veszélyforrásokat, és a védekezés módját', 'a tájékoztatás nem szükséges, elegendő a munkavédelmi szakember tájékoztatása']
    }, {
        nr: 108,
        question: '4.16. Milyen tipikus veszélyek és ártalmak ismertek a villamos energia iparban?',
        type: 'radio',
        answers: ['a villamos ipar nem veszélyes tevékenység, jelentős veszély, ártalom nincs', 'feszültség alatt, ill. feszültség közelében végzett munka, áramütés, villamos ív, extrém időjárás, egyidejűleg jelenlévő veszélyek és ártalmak']
    }, {
        nr: 109,
        question: '4.17. Minek a rövidítése az „LMRA”',
        type: 'radio',
        answers: ['munkavégzést közvetlenül megelőző kockázatértékelés (Last Minute Risk Assesment)', 'munkába állást közvetlenül megelőző kockázatértékelés, más néven: előzetes orvosi vizsgálat']
    }, {
        nr: 110,
        question: '4.18. Mi a munkavégzést közvetlenül megelőző kockázatértékelés („LMRA”) módszere?',
        type: 'radio',
        answers: ['az „LMRA” lényegében egy előre elkészített ellenőrző lista', 'amikor a munkavezető ismeretei a feladatot a beosztottakkal']
    }, {
        nr: 111,
        question: '4.19. Miért célszerű alkalmazni a munkakezdés előtti kockázatértékelést („LMRA”)?',
        type: 'radio',
        answers: ['mert egy ellenőrző lista segítségével szisztematikusan felülvizsgálhatóak az adott munkahely és munkafolyamat során felmerülő kockázati tényezők, és azok kezelési módja', 'mert, ha végignézzük a listát, és minden rendben van, nem kell egyéni védőeszközeinket használni']
    }, {
        nr: 112,
        question: '4.20. Mely tényezőket nem kell vizsgálni az LMRA során?',
        type: 'radio',
        answers: ['a feladatot megértettük, ismerjük a folyamatát, munkavégzésre alkalmas állapotban vagyunk, ismerjük a teendőket vészhelyzet esetén, védő és munkaeszközeink megfelelő állapotban vannak, azokat rendeltetésszerűen használjuk, munkakörnyezetünk alkalmas a munkavégzésre, másokat nem veszélyeztetünk', 'a munkavállalók életkorát és a személyazonosságot igazoló dokumentumok érvényességét']
    }, {
        nr: 113,
        question: '4.21. Milyen rendszerek írnak elő ellenőrző, helyesbítő tevékenységet?',
        type: 'radio',
        answers: ['pl. Minőségirányítási Rendszer, MEBIR, Környezetközpontú Irányítási Rendszer, Integrált Irányítási rendszer.', 'nemzeti jogszabályok']
    }, {
        nr: 114,
        question: '4.22. Szervezett munkavégzés során miért szükséges a munkavállalók tájékoztatása?',
        type: 'radio',
        answers: ['a MVT 54.§ (7) a, írja elő: „Az egészséget nem veszélyeztető és biztonságos munkavégzés érdekében a munkáltató köteles a szükséges utasításokat és tájékoztatást a munkavégzést megelőzően a munkavállalónak megadni', 'a tájékoztatás nem szükséges, elegendő a szakmai alkalmasság']
    }, {
        nr: 115,
        question: '4.23. Szervezett munkavégzés során miért szükséges a munkavállalók ellenőrzése?',
        type: 'radio',
        answers: ['nem szükséges, mindenki tud magára vigyázni', 'a Munkavédelmi Törvény 54. § (7) b, írja elő: a munkáltatónak rendszeresen meg kell győződnie arról, hogy a munkakörülmények megfelelnek-e a követelményeknek, a munkavállalók ismerik, illetve megtartják-e a rájuk vonatkozó rendelkezéseket']
    }, {
        nr: 116,
        question: '4.24. Miért célszerű az ellenőrző, helyesbítő tevékenységet rendszerbe foglalni?',
        type: 'radio',
        answers: ['a gazdasági szervezet működési rendjéhez igazodó ellenőrzési rendszer segíti az információk szisztematikus feldolgozását, és egyértelmű felelősségi határokat rögzít a kockázatcsökkentő intézkedések meghatározásában és végrehajtásában', 'nem célszerű külön rendszert kialakítani, a gazdálkodó szervezet Belső Ellenőrzési szervezete ezt a feladatot ellátja ']
    }, {
        nr: 117,
        question: '4.25. Milyen MVT adta keret lehetséges a munkaadók és a munkavállalók között a munkavédelmi kérdésekkel kapcsolatos tanácskozásra?',
        type: 'radio',
        answers: ['nincs ilyen rendelkezés a MVT-ben', 'a felek 20 főnél több foglalkoztatott esetében Paritásos Munkavédelmi Testületet hozhatnak létre ']
    }, {
        nr: 118,
        question: '4.26. Miért javasolt céges munkavédelmi napokat szervezni?',
        type: 'radio',
        answers: ['mert általában munkaidőben van, és addig sem kell dolgozni', 'mert lehetőség nyílik a szervezeti egységek és szervezeti szintek közötti informális, kötetlen dialógusra']
    }, {
        nr: 119,
        question: '4.27. Miért javasolt céges, családi munkavédelmi napokat szervezni?',
        type: 'radio',
        answers: ['a gyerekek jót tudnak játszani', 'a munkáltatónak lehetősége nyílik bemutatni a munkabiztonságra irányuló erőfeszítéseket, a család és a privát szféra oldaláról is erősíthető a munkavállalók biztonságtudata']
    }, {
        nr: 120,
        question: '4.28. Miért célszerű az alvállalkozókkal, partnercégekkel dialógust folytatni?',
        type: 'radio',
        answers: ['a beszélgetések során a vezetők és a beosztottak kölcsönösen megismerhetik egymás szokásait', 'a konzultációk során kölcsönösen megismerhetőek a cégkultúrák, a belső folyamatok']
    }, {
        nr: 121,
        question: '4.29. Milyen témákban érdemes dialógust folytatni a partnercégekkel, alvállalkozókkal?',
        type: 'radio',
        answers: ['új előírások bevezetése előtt, a követelmények egységes értelmezése céljából, az együttműködés javításáról, tapasztalatcsere munkabiztonsági célú ellenőrzésekről, balesetekről, kvázi balesetekről', 'a béren kívüli juttatások lehetséges módozatairól']
    }, {
        nr: 122,
        question: '4.30. Milyen munkahelyen kívüli szakmai platformokon van lehetősége a prevenció gyakorlatáról tájékozódni?',
        type: 'radio',
        answers: ['internet, face book', 'Magyar Elektrotechnikai Egyesület, iparági szakbizottságok, munkabiztonsággal foglalkozó konferenciák, munkavédelmi érdekképviselők képzése']
    }, {
        nr: 123,
        question: '5.1. Rendelkezik a Munkavédelmi Törvény a munkáltatók oktatási kötelezettségeiről?',
        type: 'radio',
        answers: ['igen, az alaprendelkezések a Mvt. 55. § részben találhatóak', 'nem, az oktatások rendje csak a belső szabályzatokban van előírva']
    }, {
        nr: 124,
        question: '5.2. Mely esetekben kell a munkáltatónak oktatnia a munkavállalókat?',
        type: 'radio',
        answers: ['csak munkába álláskor', 'munkába álláskor, munkahely vagy munkakör megváltozásakor, valamint az egészséget nem veszélyeztető és biztonságos munkavégzés követelményeinek változásakor, munkaeszköz átalakításakor vagy új munkaeszköz üzembe helyezésekor, új technológia bevezetésekor']
    }, {
        nr: 125,
        question: '5.3. Része a munkavédelmi oktatás a munkaidőnek?',
        type: 'radio',
        answers: ['nem, mert akkor a munkavállalók az oktatás ideje alatt ténylegesen nem dolgoznak', 'igen, az oktatást rendes munkaidőben kell megtartani']
    }, {
        nr: 126,
        question: '5.4. Szükséges időszakonkénti ismétlő oktatás?',
        type: 'radio',
        answers: ['nem', 'igen, az oktatást szükség esetén időszakonként – a megváltozott vagy új kockázatokat, megelőzési intézkedéseket is figyelembe véve – meg kell ismételni']
    }, {
        nr: 127,
        question: '5.5. Szükséges a munkavédelmi oktatást dokumentálni?',
        type: 'radio',
        answers: ['nem, a munkaidő nyilvántartás megfelelően bizonyítja, hogy az oktatás megtörtént', 'igen, jellemzően Munkavédelmi oktatási naplóban (helyszín, időpont, résztvevők, tematika)']
    }, {
        nr: 128,
        question: '5.6. Az oktatási tematika elkészítése kinek a feladata?',
        type: 'radio',
        answers: ['a munkavédelmi képviselő készíti', 'munkabiztonsági és munkaegészségügyi szaktevékenység']
    }, {
        nr: 129,
        question: '5.7. Mi a célja a munkavédelmi oktatásnak a munkába álláskor?',
        type: 'radio',
        answers: ['az alapvető cél, hogy a munkavállaló általános képet kapjon a munkáltató munkavédelmi szervezetének felépítéséről, a főbb munkabiztonsághoz kapcsolódó folyamatokról, és megkapja a munkaköréhez / feladatához szükséges ismereteket', 'a cél, hogy az új munkavállaló megismerje azokat a kollégákat, akikkel együtt fog dolgozni']
    }, {
        nr: 130,
        question: '5.8. Milyen főbb részekből álljon az oktatási tematika munkába álláskor?',
        type: 'radio',
        answers: ['általános munkavédelmi ismeretek, és az adott munkakör betöltéséhez szükséges ismeretek', 'a telephelyeket és az összes munkatársakat kell bemutatni az új munkavállalónak']
    }, {
        nr: 131,
        question: '5.9. Milyen ismeretekből álljon az oktatás munkahely vagy munkakör megváltozásakor, munkaeszköz átalakításakor, vagy új munkaeszköz üzembe helyezésekor, új technológia bevezetésekor?',
        type: 'radio',
        answers: ['Azokra az ismeretekre kell helyezni a hangsúlyt, amelyek az új veszélyek és kockázatok megismerését, ill. azok megelőzésének, kezelésének módjait tartalmazza.', 'Nem szükséges oktatás, elegendő a munkatársaknak a kezelési, karbantartási és technológiai utasításokat átadni']
    }, {
        nr: 132,
        question: '5.10. Soron kívüli munkavédelmi oktatást milyen esetben kell tartani? ',
        type: 'radio',
        answers: ['minden esetben, ha személyi hibából rákkeltő jut a munkatérbe', 'nincs meghatározva, ha a munkáltató elrendeli']
    }, {
        nr: 133,
        question: '5.11. Hogyan kell összeállítani a munkavédelmi oktatások ágazat specifikus részeit?',
        type: 'radio',
        answers: ['a tematikát a célcsoport napi tevékenységéhez igazodva kell felépíteni', 'az MSZ 1585 legfontosabb fejezeteit kell ismertetni']
    }, {
        nr: 134,
        question: '5.12. Miért javasolt a munkahelyi, ill. szervezeti egység vezetők megjelenése a munkavállalók munkavédelmi oktatásain?',
        type: 'radio',
        answers: ['a vezetők jelenléte megerősíti a munkabiztonság fontosságát, segíti a gyorsabb információáramlást, a felmerülő problémák gyorsabb hatékonyabb kezelését', 'ha vezetők megjelennek a munkavédelmi oktatásokon, a munkatársakat nem kell ellenőrizniük a munkaterületen, munkahelyen']
    }, {
        nr: 135,
        question: '5.13. Melyek a munkavédelmi oktatások legfontosabb ágazat specifikus témakörei?',
        type: 'radio',
        answers: ['környezetvédelem: levegőtisztaság védelem, madárvédelem', 'védekezés villamos veszélyek ellen, üzemeltetési szabályzatok releváns részei']
    }, {
        nr: 136,
        question: '5.14. Ki a villamosan szakképzett személy?',
        type: 'radio',
        answers: ['aki olyan, az adott munkaterületre vonatkozó szakmai képesítéssel, tudással és gyakorlattal rendelkezik, amely képessé teszi a villamosság által előidézhető kockázat értékelésére és a veszélyek elkerülésére.', 'az a személy, akit kioktattak, ezáltal képessé vált a villamosság által elő idézhető veszélyek elkerülésére.']
    }, {
        nr: 137,
        question: '5.15. Hogyan biztosítható a munkavédelmi képviselők megfelelő képzése?',
        type: 'radio',
        answers: ['A munkavédelmi képviselőnek megválasztását követő hat hónapon belül el kell végeznie a legalább 16 óraszámú alapképzést.', 'A megválasztott képviselő önállóan maga végzi el a felkészülést']
    }, {
        nr: 138,
        question: '5.16. Mit nevezünk villamos munkának?',
        type: 'radio',
        answers: ['a villamos berendezésen, a villamos berendezéssel vagy a villamos berendezés közelében végzett munka, pl. vizsgálat és mérés, javítás, alkatrészcsere, módosítás, bővítés, szerelés, karbantartás és ellenőrzés', 'csak a FAM beavatkozásokat nevezzük villamos munkának']
    }, {
        nr: 139,
        question: '5.17. Mit nevezünk üzemi munkának?',
        type: 'radio',
        answers: ['minden olyan villamos munka, amelyhez villamos jellegű kioktatás vagy szakképzettség szükséges', 'csak a zárt térben (üzemben) végzett villamos munkát nevezzük üzemi munkának']
    }, {
        nr: 140,
        question: '5.18. Mi a munkavezetőre vonatkozó legfontosabb követelmény?',
        type: 'radio',
        answers: ['a részfeladatok végrehajtása előtt eligazítást kell tartania a munkacsoport minden tagja részére', 'a munkavezető köteles kioktatni a munkavégzésben részt vevő személyeket az összes indokolt, várható, nem könnyen felismerhető veszélyről']
    }, {
        nr: 141,
        question: '5.19. Az MSZ 1585 hogyan sorolja be az üzemi munkát végző személyzetet?',
        type: 'radio',
        answers: ['munkavezető, beosztott szerelő, segítő', 'a szabvány I., II., II. és IV. csoportba sorolja a személyzetet']
    }, {
        nr: 142,
        question: '5.20. Az MSZ 1585 szerint kik tartoznak a I. csoportba?',
        type: 'radio',
        answers: ['azok a személyek, akiknek az általuk végzendő tevékenységek szempontjából semmiféle szakképzettségük nincs, és kioktatást sem kaptak (képzetlen személyek).', 'azok a személyek, akik az általuk végzendő tevékenységre műszaki, de nem villamos jellegű kioktatást kaptak, vagy akiknek e munkák végzésére jogosító nem villamos szakképzettségük van.']
    }, {
        nr: 143,
        question: '5.21. Az MSZ 1585 szerint kik tartoznak a II. csoportba?',
        type: 'radio',
        answers: ['azok a személyek, akik az általuk végzendő tevékenységre műszaki, de nem villamos jellegű kioktatást kaptak, vagy akiknek e munkák végzésére jogosító nem villamos szakképzettségük van.', 'azok a villamos szakképzettséggel nem rendelkező személyek, akiket az általuk végzendő munkák villamos veszélyeire és az ezzel kapcsolatos magatartásra bizonyítottan kioktattak.']
    }, {
        nr: 144,
        question: '5.22. Az MSZ 1585 szerint kik tartoznak a III. csoportba?',
        type: 'radio',
        answers: ['azok a személyek, akik az általuk végzendő tevékenységre műszaki, de nem villamos jellegű kioktatást kaptak, vagy akiknek e munkák végzésére jogosító nem villamos szakképzettségük van.', 'azok a villamos szakképzettséggel nem rendelkező személyek, akiket az általuk végzendő munkák villamos veszélyeire és az ezzel kapcsolatos magatartásra bizonyítottan kioktattak.']
    }, {
        nr: 145,
        question: '5.23. Az MSZ 1585 szerint kik tartoznak a IV. csoportba?',
        type: 'radio',
        answers: ['azok a villamos szakképzettséggel nem rendelkező személyek, akiket az általuk végzendő munkák villamos veszélyeire és az ezzel kapcsolatos magatartásra bizonyítottan kioktattak.', 'azok a villamos energetikai (erősáramú) szakképzettségű személyek, akiket szakképesítésük az általuk végzendő munkára és szerelési felügyeletre általánosan (nem egy meghatározott villamos berendezésre) alkalmasnak nyilvánít.']
    }, {
        nr: 146,
        question: '5.24. A munkáltatónak kell-e Vészhelyzeti tervet készíteni?',
        type: 'radio',
        answers: ['A munkahely jellegére, helyzetére, kiterjedésére, a veszélyforrás hatására, valamint a munkavégzés hatókörében tartózkodókra tekintettel kell a mentési tervet elkészíteni,', 'A mentési terv készítésére a munkáltató nem kötelezett ']
    }, {
        nr: 147,
        question: '5.25. Ki készítheti el a Vészhelyzeti tervet?',
        type: 'radio',
        answers: ['a mentési terv elkészítése munkabiztonsági szaktevékenységnek minősül.', 'a terület illetékes katasztrófavédelmi szakhatóság']
    }, {
        nr: 148,
        question: '5.26. Miért szükséges az ágazatban a biztonságtudat fejlesztése?',
        type: 'radio',
        answers: ['a munkavállalók gyakran „nyitott munkahelyeken”, vagy egyedül dolgoznak, tehát biztonságuk saját maguktól függ', 'nem szükséges a biztonságtudat fejlesztése, mert a munkáltató folyamatosan ellenőrzi a munkavállalókat, ezért a szabályokat mindenki, mindenhol betartja ']
    }, {
        nr: 149,
        question: '5.27. Miért fontos az „élményszerű” oktatás?',
        type: 'radio',
        answers: ['az élményszerű oktatásokon mindenki jól érzi magát', 'az élményszerű oktatásoknak hosszabb a hatása']
    }, {
        nr: 150,
        question: '5.28. Miért célszerű folyamatos, rendszerbe foglalt munkavédelmi kampányt, akciókat szervezni?',
        type: 'radio',
        answers: ['mert a reprezentációs keret terhére a költségek elszámolhatóak', 'a kampányok segítik a biztonságtudat folyamatos fenntartását ']
    }, {
        nr: 151,
        question: '5.29. Miért javasolt vállalati aranyszabályokat, tabuszabályokat, „Tíz parancsolat”-ot megfogalmazni?',
        type: 'radio',
        answers: ['a vezetés így tudja kommunikálni a munkatársak felé a vállalat munkabiztonsági kultúrájának alapvető, megsérthetetlen normáit, értékeit', 'azért, hogy a munkatársak megismerjék azokat a szabályokat, amelyeket ha megszegnek, biztosan ki lesznek rúgva']
    }, {
        nr: 152,
        question: '5.30. Miért célszerű bevezetni asszertív kommunikációs tréningeket?',
        type: 'radio',
        answers: ['a különböző személyiségtípusú kollégák konfliktusmenetes együttműködését és a biztonságosabb munkavégzést segíti', 'ilyen tréningek nem szükségesek, mert a munkahelyen általában mindenki mindenkivel jóban van']
    }, {
        nr: 153,
        question: '6.1. Mi az elosztó hálózati engedélyes alapvető feladata a 2007. évi LXXXVI. törvény (VET) szerint?',
        type: 'radio',
        answers: ['a szünetmentes villamos energia ellátás biztosítása', 'a működési engedélyben meghatározott elosztó hálózat irányítása és üzemvitele biztonságának biztosítása']
    }, {
        nr: 154,
        question: '6.2. Mire jogosult az elosztói engedélyes a VET alapján, ha a Hatóságnak üzembe helyezését / üzemeltetését bejelentette?',
        type: 'radio',
        answers: ['a bejelentés alapján az építményeket üzemeltetheti, karbantarthatja, kijavíthatja és átalakíthatja, felújíthatja, továbbá a közcélú hálózat, termelői vezeték, magánvezeték vagy a közvetlen vezeték mentén lévő, a biztonsági övezetet sértő növényzetet eltávolíthatja.', 'az elosztó hálózati díjjal 60 napon túl tartozó fogyasztókat kikapcsolhatja ']
    }, {
        nr: 155,
        question: '6.3. Hogyan határozza meg a VET 3. § a biztonsági övezet fogalmát?',
        type: 'radio',
        answers: ['a feszültség alatt álló vezeték körüli azon térrész, amin kívül az üzemi személyzet biztonságosan dolgozhat', 'az a földrajzi terület, amelyre a tervezett vagy létesült villamos mű, termelői vezeték, magánvezeték, vagy közvetlen vezeték számottevő hatást gyakorol']
    }, {
        nr: 156,
        question: '6.4. Mit nevezünk burkolt vezetéknek?',
        type: 'radio',
        answers: ['olyan, szigetelő anyaggal bevont vezetősodrony, amelynél a szigetelő anyag nem elégíti ki a közvetlen érintésvédelem követelményeit', 'olyan, szigetelő anyaggal bevont vezetősodrony, amelynél a szigetelő anyag kielégíti a közvetlen érintésvédelem követelményeit']
    }, {
        nr: 157,
        question: '6.5. Mit nevezünk kábelnek?',
        type: 'radio',
        answers: ['kábelnek nevezzük a három, vagy több vezetőérrel rendelkező vezetéket', 'olyan szigetelt vezeték, amely érszigetelésen felül olyan köpenyszerkezettel is rendelkezik, amely mechanikai védelmet nyújt a szigetelésnek és az érvezetőknek']
    }, {
        nr: 158,
        question: '6.6. Mint nevezünk szigetelt vezetéknek?',
        type: 'radio',
        answers: ['olyan, szigetelő anyaggal bevont vezetősodrony, amelynél a szigetelő anyag kielégíti a közvetlen érintésvédelem követelményeit', 'olyan, szigetelő anyaggal bevont vezetősodrony, amelynél a szigetelő anyag biztosítja a feszültség alatt álló vezeték csapadékvíz elleni védelmet']
    }, {
        nr: 159,
        question: '6.7. Mi a biztonsági övezet terjedelme föld feletti vezeték esetében?',
        type: 'radio',
        answers: ['a vezeték névleges feszültségétől függően, a vezeték mindkét oldalán a szélső, nyugalomban lévő áramvezetőktől vízszintesen és nyomvonalukra merőlegesen mért függőleges síkokig terjed', 'a vezeték névleges feszültségétől függően, az a henger alakú űrszelvényt, melynek tengelye a vezetékrendszer középső fázisvezetője']
    }, {
        nr: 160,
        question: '6.8. Mi a földben elhelyezett vezeték biztonsági övezet terjedelme?',
        type: 'radio',
        answers: ['a földben elhelyezett vezeték biztonsági övezete a vezeték névleges feszültségétől függő, henger alakú űrszelvény', 'a földben elhelyezett vezeték biztonsági övezete a vezeték névleges feszültségétől függ. A biztonsági övezet a vezeték szélső pontjától vízszintesen és nyomvonalára merőlegesen mért távolságokra lévő függőleges síkokig terjed.']
    }, {
        nr: 161,
        question: '6.9. Mi az ideiglenes berendezések létesítésére vonatkozó fő szabály?',
        type: 'radio',
        answers: ['Ideiglenes berendezést biztonsági szempontból az állandó berendezésekre előírt szabályoknak megfelelően kell létesíteni. Megengedhető azonban a berendezés üzemidejének megfelelően kisebb élettartamú készülékek, anyagok, gépek, feliratok alkalmazása, továbbá a kezelési kényelem szempontjából eltérő kivitel.', 'Ideiglenes berendezést biztonsági szempontból minden esetben az állandó berendezésekre előírt szabályoknak megfelelően kell létesíteni.']
    }, {
        nr: 162,
        question: '6.10. Milyen kezelőszervet kell a távvezérelt vagy önműködő vezérlésű berendezések közelében felszerelni?',
        type: 'radio',
        answers: ['távvezérelt vagy önműködő vezérlésű berendezéshez, továbbá ha az indítás helyéről a berendezés nem látható, a berendezés közelében olyan kezelőszervet kell felszerelni, amellyel a berendezés nem kívánatos indítása megakadályozható', 'a távvezérelt vagy önműködő vezérlésű berendezések közelében, ill. felszerelési helyükön nem szükséges semmiféle járulékos biztonsági kezelőszerv']
    }, {
        nr: 163,
        question: '6.11. Kinek a feladata a villamosművi üzemi berendezés végleges feszültség alá helyezése?',
        type: 'radio',
        answers: ['az üzembe helyezés a kivitelező feladata, mert a kivitelező létesítette, és ő ismeri a legjobban a villamos mű kezelését, működtetését', 'a végleges feszültség alá helyezés, és az ezzel kapcsolatos biztonsági intézkedések megtétele az engedélyes, illetve megbízása alapján az üzemeltető feladata, függetlenül a berendezés tulajdonjogától.']
    }, {
        nr: 164,
        question: '6.12. Mi tartozik a „Megállapodási kötelezettségek teljesítése” fogalomba?',
        type: 'radio',
        answers: ['megfelelő teljesítés esetén a beruházó köteles a kivitelező részére a vállalkozási szerződésben meghatározott díjat kifizetnie', 'átadás-átvételkor a beruházónak az üzemeltető számára át kell adni a villamos mű biztonságos kezeléséhez, karbantartásához szükséges terveket, a kezelési utasításokat, továbbá a tervező és kivitelező nyilatkozatát arról, hogy az üzemi berendezés és annak biztonsága mindenben megfelel az érvényben lévő jogszabályoknak és a közzétett magyar nemzeti szabványok biztonsági előírásainak.']
    }, {
        nr: 165,
        question: '6.13. A beruházónak kit, kiket kell meghívnia az üzembe helyezési eljárásra?',
        type: 'radio',
        answers: ['akiktől szüksége hatósági és szakhatósági engedélyeket beszerezni, a villamos mű munkavédelmi szervezetének vezetőjét, ill. mindazokat, akiket az üzembe helyezést engedélyező a műszaki biztonság szempontjából szükségesnek tart', 'meg kell hívni az üzemeltető állományába tartozó valamennyi szakképzett munkavállalót és a területi Munkavédelmi érdekképviselőt']
    }, {
        nr: 166,
        question: '6.14. Mely esetekben írja elő az Üzemi Szabályzat az üzemeltetőknek, hogy (üzemviteli) megállapodást kell kötniük?',
        type: 'radio',
        answers: ['azon üzemeltetőknek, amelyeknek a berendezései kapcsolatban vannak egymással, műszaki-biztonsági szempontból (üzemviteli) megállapodást kell kötniük', 'azon üzemeltetőknek, akik nem rendelkeznek kellő számú helyismereti vizsgát tett munkavállalóval, (üzemviteli) megállapodást kell kötniük']
    }, {
        nr: 167,
        question: '6.15. Hogyan kell ellenőrizni a műszaki biztonságot szolgáló berendezések meglétét?',
        type: 'radio',
        answers: ['A berendezést a szerelés befejezése után felül kell vizsgálni abból a szempontból, hogy az megfelel-e az érvényben lévő munka- és egészségvédelmi előírásoknak', 'A berendezést a szerelés befejezése után felül kell vizsgálni abból a szempontból, hogy az megfelel-e kiviteli terveknek']
    }, {
        nr: 168,
        question: '6.16. Kinek / kiknek kötelessége a munkavédelmi szemlén a megjelenés?',
        type: 'radio',
        answers: ['az üzemeltető munkavédelmi vezetője, vagy az általa megbízott személy, az üzemeltető megbízottja, a beruházó megbízottja, a tervező megbízottja, a kivitelező megbízottja', 'a beruházónak, a kivitelezőnek, az üzemeltetőnek és a Munkavédelmi érdekképviselőnek']
    }, {
        nr: 169,
        question: '6.17. Miért szükséges a villamos berendezés üzembe helyezés előtt munkavédelmi szemle?',
        type: 'radio',
        answers: ['nem szükséges szemle, mert az üzemeltető és a beruházó által kiállított teljesítésigazolás a villamos berendezés megfelelőségét tanúsítja', 'megfelelőség esetén a munkavédelmi szemle után a résztvevőknek jegyzőkönyvben kell nyilatkozni, hogy a berendezés megfelel az érvényben lévő munka- és egészségvédelmi előírásoknak']
    }, {
        nr: 170,
        question: '6.18. Hogyan történik az üzembe helyezés engedélyezése?',
        type: 'radio',
        answers: ['a villamos berendezés megfelelőségéről kiállított jegyzőkönyv alapján az üzemeltető illetékes üzemviteli vezetője a berendezés üzembe helyezését munkavédelmi szempontból engedélyezheti', 'ha a kivitelező a munkaterületről levonult, és az üzemeltetők is szabályosan kitöltötték a munkaterület átadás / átvételi jegyzőkönyvet, az üzemeltetők munkavezetője az üzembe helyezést engedélyezheti']
    }, {
        nr: 171,
        question: '6.19. Mit nevezünk átalakításnak?',
        type: 'radio',
        answers: ['minden olyan beavatkozást, amely a villamos berendezés eredeti funkciójának, műszaki kialakításának, technológiai paramétereinek megváltoztatását eredményezi', 'minden olyan beavatkozást, amikor az elosztói engedélyes a villamos energia szállítási feszültségszintjét megváltoztatja, átalakítja']
    }, {
        nr: 172,
        question: '6.20. Mi az egyenértékűségi nyilatkozat?',
        type: 'radio',
        answers: ['a villamos tervező nyilatkozata arról, hogy szabványok előírásaitól eltérően a tervben alkalmazott műszaki megoldásokat biztonsági és műszaki szempontból a szabvány követelményeivel legalább egyenértékűnek nyilvánítja', 'a villamos tervező nyilatkozata arról, hogy szabványok előírásaitól a tervezés során jelentősen nem kellett eltérni, tehát az alkalmazott megoldások lényegében egyenértékűek a szabványok előírásaival']
    }, {
        nr: 173,
        question: '6.21. Mi a „jelentős villamos berendezés”?',
        type: 'radio',
        answers: ['minden nagy kiterjedésű, 1000 V feletti névleges feszültségen üzemelő berendezés', 'pl. a potenciálisan robbanásveszélyes létesítmény berendezése, vagy a villamosműhöz, magánvezetékhez, termelői vezetékhez vagy közvetlen vezetékhez csatlakozó fogyasztói berendezés']
    }, {
        nr: 174,
        question: '6.22. Mit nevezünk üzemeltetési útmutatónak?',
        type: 'radio',
        answers: ['egy adott villamos berendezés kezelésére vonatkozó előírások összessége', 'a tervező / kivitelező által az üzemi szabályzat kidolgozásához készített műszaki összeállítás arról, hogy a berendezés biztonságos kezeléséhez milyen szakképzettség, kioktatottság szükséges, továbbá milyen - a megkövetelt szakismereteken túlmenő - helyi követelményeknek kell megfelelni']
    }, {
        nr: 175,
        question: '6.23. Mi a ”villamos üzemi szabályzat”?',
        type: 'radio',
        answers: ['az általános, nem egy adott berendezés egyedi körülményeire kidolgozott, magatartási és kezelési szabályok gyűjteménye', 'egy adott berendezés egyedi körülményeire kidolgozott, magatartási és kezelési szabálygyűjteménye']
    }, {
        nr: 176,
        question: '6.24. Létesítés során el lehet térni a Villamos Műszaki Biztonsági Szabályzat (VMBSz) előírásaitól?',
        type: 'radio',
        answers: ['eltérés nem lehetséges', 'a tervező eltérhet, de csak abban az esetben, ha igazolja, hogy a VMBSz előírásai szerint elérhető, vagy magasabb műszaki biztonsági szintet más módon is biztosítja']
    }, {
        nr: 177,
        question: '6.25. Milyen gyakorisággal kell az 1000 V-nál nagyobb névleges feszültségű villamos berendezések időszakos általános szabványossági felülvizsgálatát elvégezni?',
        type: 'radio',
        answers: ['háromévente', 'hatévente']
    }, {
        nr: 178,
        question: '6.26. Milyen gyakorisággal kell a villamos berendezés áramütés elleni védelem szempontjából történő időszakos szabványossági felülvizsgálatát a használatbavételét követően elvégezni?',
        type: 'radio',
        answers: ['legalább 6 évenként', 'háromévente']
    }, {
        nr: 179,
        question: '6.27. Mi a Vészhelyzeti terv célja?',
        type: 'radio',
        answers: ['a Vészhelyzeti terv a gazdálkodó szervezet teendőit fogalja össze egy hirtelen bekövetkező gazdasági válság esetére', 'a káresemények megelőzése, ill. a káresemény(ek) bekövetkezésekor a tudatos és felkészült helyzetkezelés, a károk minimalizálása']
    }, {
        nr: 180,
        question: '6.28. Mik a vészhelyzet kezelés alapelve(i)?',
        type: 'radio',
        answers: ['káresemény, vészhelyzet nagy valószínűséggel valamikor bekövetkezik, továbbá: a hatékony vészhelyzet kezelés szükséges feltétele a munkáltató elkötelezettsége és a szervezet felkészültsége', 'a vészhelyzetek kezeléséhez a legfontosabb, hogy a gazdálkodó szervezetnek legyen egy jó felelősségbiztosítása']
    }, {
        nr: 181,
        question: '6.29. Melyek a főbb lépései egy Vészhelyzeti terv elkészítésének?',
        type: 'radio',
        answers: ['a tervkészítő csapat kijelölése, a kockázatok feltárása, a vészhelyzeti stratégia kialakítása, a munkatársak képzése, folyamatos változáskövetés', 'kockázatelemzés és a kockázat csökkentő intézkedések bevezetése']
    }, {
        nr: 182,
        question: '6.30. Melyek a Vészhelyzeti terv legfontosabb elemei?',
        type: 'radio',
        answers: ['egyfelől a vészhelyzetek kialakulását megelőző intézkedések meghatározása, másfelől vészhelyzet bekövetkezése esetére az eljárások, intézkedések, teendők, alkalmazandó eszközök, védőeszközök meghatározása és a vészhelyzetek kezeléséhez szükséges további információk rendelkezésre állásának biztosítása', 'a gazdálkodó szervezet által használt veszélyes anyagok Biztonsági adatlapja']
    }, {
        nr: 183,
        question: '7.1. Melyik törvény szabályozza, hogy minden munkavállalónak joga van az egészségét, biztonságát és méltóságát tiszteletben tartó munkafeltételekhez?',
        type: 'radio',
        answers: ['az 1997. évi CLIV. törvény az egészségügyről', 'Magyarország Alaptörvénye']
    }, {
        nr: 184,
        question: '7.2. Milyen kérdésben van döntési jogköre az Országos Munkavédelmi Bizottságnak?',
        type: 'radio',
        answers: ['az Országos Munkavédelmi Bizottság dönt a nevelés és az oktatás területén a biztonságos életvitelre, a szakmai oktatás területén az egészséget nem veszélyeztető és a biztonságos munkavégzés szabályaira vonatkozó ismeretanyag meghatározásával kapcsolatos kérdésekben', 'az egyéni védőeszközök juttatásával kapcsolatos szabályok meghatározása tekintetében']
    }, {
        nr: 185,
        question: '7.3. Milyen nyelven kell kioktatni a munkavállalót az egészséget nem veszélyeztető és biztonságos munkavégzés reá vonatkozó szabályairól?',
        type: 'radio',
        answers: ['a munkáltató magyar nyelven köteles ismertetni a munkavállalókkal az egészséget nem veszélyeztető és biztonságos munkavégzés reá vonatkozó szabályait', 'a munkáltató felelős azért, hogy minden munkavállaló az általa értett nyelven ismerhesse meg az egészséget nem veszélyeztető és biztonságos munkavégzés reá vonatkozó szabályait']
    }, {
        nr: 186,
        question: '7.4. Köteles-e a munkáltató az egészséges és biztonságos munkavégzés érdekében a munkavállalókkal, illetve munkavédelmi képviselőikkel tanácskozni?',
        type: 'radio',
        answers: ['a munkáltató az egészséges és biztonságos munkavégzés érdekében köteles a munkavállalókkal, illetve munkavédelmi képviselőikkel tanácskozni', 'a szakszervezetnek és az Üzemi tanácsnak kell a munkavállalókkal, illetve munkavédelmi képviselőikkel tanácskozni']
    }, {
        nr: 187,
        question: '7.5. Amennyiben 20 főnél kevesebb munkavállalót foglalkoztat a munkavállaló és nem választottak munkavédelmi képviselőt, akkor is meg kell-e szerveznie a munkáltatónak a tanácskozást?',
        type: 'radio',
        answers: ['a húsz főnél kevesebb munkavállalót foglalkoztató munkáltatónál - amennyiben nem kerül sor munkavédelmi képviselő választásra - a munkáltatónak a 70. §-ban meghatározottak szerint kell a munkavállalókkal tanácskoznia', 'ahol 20 főnél kevesebb munkavállalót foglalkoztat a munkáltató, ott nem szükséges a tanácskozás megszervezése, mivel nagyon alacsony a munkavállalók létszáma']
    }, {
        nr: 188,
        question: '7.6. Köteles-e a munkáltató a munkavédelmi kérdésben jártas személlyel képviseltetni magát a tanácskozáson?',
        type: 'radio',
        answers: ['a kiegyensúlyozott részvétel érdekében a munkáltató köteles a munkavédelmi kérdésben intézkedési jogkörrel bíró személlyel képviseltetnie magát a tanácskozáson', 'a tanácskozáson a Szakszervezet, Üzemi Tanács, ha ilyen nincs, akkor az Üzemi megbízott köteles képviseltetni magát a tanácskozáson']
    }, {
        nr: 189,
        question: '7.7. A tanácskozáson résztvevő munkavállalóknak van-e döntési jogkörük a tanácskozáson elhangzott felvetésekkel kapcsolatosan?',
        type: 'radio',
        answers: ['a tanácskozáson résztvevő munkavállalóknak a tanácskozás kapcsán nincs sem döntési, sem egyetértési jogkörük', 'a tanácskozáson részt vevő munkavállalók csak azokban a kérdésekben dönthetnek, amelyek a biztonságos munkavégzésről szólnak']
    }, {
        nr: 190,
        question: '7.8. Milyen kötelezettsége van a munkavállalónak a munkavégzés során, annak érdekében, hogy az saját vagy más egészségét és testi épségét ne veszélyeztesse?',
        type: 'radio',
        answers: ['a munkavállaló köteles munkatársaival együttműködni, és munkáját úgy végezni, hogy ez saját vagy más egészségét és testi épségét ne veszélyeztesse', 'a munkavállaló csak a termelési szempontok betartását köteles figyelembe venni']
    }, {
        nr: 191,
        question: '7.9. Milyen esetben tagadhatja meg a munkavállaló a munkavégzést?',
        type: 'radio',
        answers: ['a munkavállaló jogosult megtagadni a munkavégzést, ha azzal életét, egészségét, vagy testi épségét közvetlenül és súlyosan veszélyeztetné', 'a munkavállaló megtagadhatja a munkát, ha hőmérséklet eléri a 24 C. fokot']
    }, {
        nr: 192,
        question: '7.10. A munkavédelmi képviselő milyen esetben jogosult meggyőződni a munkahelyeken az egészséget nem veszélyeztető és biztonságos munkavégzés követelményeinek érvényesüléséről?',
        type: 'radio',
        answers: ['a képviselő minden esetben jogosult meggyőződni arról, hogy biztosított-e a munkahelyek, a munkaeszközök és egyéni védőeszközök biztonságos állapota', 'a munkavédelmi képviselő csak akkor jogosult az ellenőrzésre, ha erre a Munkavédelmi Bizottság felkérte']
    }, {
        nr: 193,
        question: '7.11. A Munkavédelmi képviselő közreműködhet-e a foglalkozási megbetegedések körülményeinek feltárásában?',
        type: 'radio',
        answers: ['igen, de csak akkor, ha az adatvédelmi előírásokat betartja', 'nem, mert ez kizárólag a foglalkozás-egészségügyi orvos dolga']
    }, {
        nr: 194,
        question: '7.12. A munkáltató köteles-e biztosítani a munkavédelmi képviselő(k) rendszeres továbbképzését?',
        type: 'radio',
        answers: ['a képviselő megválasztását követő egy éven belül legalább 16 órás képzésben, ezt követően, valamint újraválasztása esetén évente legalább 8 órás továbbképzésben való részvétel lehetőségét a munkáltatónak biztosítania kell', 'csak akkor, ha súlyos baleset következik be']
    }, {
        nr: 195,
        question: '7.13. A Munkavédelmi képviselő jogosult-e munkahelyekre belépni ellenőrzés céljából?',
        type: 'radio',
        answers: ['igen, de csak munkaidőben', 'igen, de csak munkaidőben és ha a munkahely működési területéhez tartozik']
    }, {
        nr: 196,
        question: '7. 14. Jogai gyakorlásában akadályozható-e a munkavédelmi képviselő, illetve a munkavédelmi bizottság?',
        type: 'radio',
        answers: ['a munkavédelmi képviselő (bizottság) jogai gyakorlásában nem akadályozható és jogai gyakorlása miatt hátrány nem érheti', 'igen, ha a vállalat érdekei ezt úgy kívánják']
    }, {
        nr: 197,
        question: '7.15. Ki viseli a munkavédelmi képviselő képzésének a költségeit?',
        type: 'radio',
        answers: ['a Munkavédelmi Bizottság', 'a munkáltató, de csak akkor, ha a képzés rendes munkaidőben történik a felnőttképzésről szóló törvény szerinti tevékenység betartásával']
    }, {
        nr: 198,
        question: '7.16. A Munkavédelmi Bizottság tárgyalásán köteles-e részt venni a munkáltató, vagy hatáskörrel rendelkező megbízottja?',
        type: 'radio',
        answers: ['a munkáltató, vagy hatáskörrel rendelkező megbízottja a Munkavédelmi Bizottság minden ülésén köteles részt venni', 'igen, de csak akkor, ha azt a Bizottság kezdeményezi']
    }, {
        nr: 199,
        question: '7.17. A munkavédelmi képviselőnek (Munkavédelmi Bizottságnak), milyen jogosítványai vannak a Vállalati Munkavédelmi Szabályzat kiadásával kapcsolatosan?',
        type: 'radio',
        answers: ['a munkavédelmi képviselőnek (Munkavédelmi Bizottságnak), a Vállalati Munkavédelmi Szabályzat kiadásával kapcsolatosan egyetértési joga van', 'a munkavédelmi képviselőnek (Munkavédelmi Bizottságnak), a Vállalati Munkavédelmi Szabályzat kiadásával kapcsolatosan véleményezési joga van']
    }, {
        nr: 200,
        question: '7.18. Kötelező-e a Munkavédelmi Bizottságot megalakítani, ha legalább 3 fő képviselőt választottak?',
        type: 'radio',
        answers: ['nem, csak lehetőség abban az esetben, ha legalább 3 fő képviselőt választottak', 'igen, de csak akkor, ha legalább 5 fő képviselőt választottak']
    }, {
        nr: 201,
        question: '7.19. A munkavédelmi képviselő kérhet e tájékoztatást a munkáltatótól?',
        type: 'radio',
        answers: ['a munkavédelmi képviselő tájékoztatást kérhet a munkáltatótól, de csak abban az esetben, ha ehhez a képviselő engedélyt kapott a Munkavédelmi Bizottságtól', 'igen, minden olyan kérdésben, amely érinti az egészséget nem veszélyeztető és biztonságos munkavégzést']
    }, {
        nr: 202,
        question: '7. 20. A munkavédelmi képviselőt megilleti - e havi munkaidejének legalább 10 százalékos munkaidő kedvezménye?',
        type: 'radio',
        answers: ['a munkavédelmi képviselőt, ha ezt a képviselői feladatai ellátására fordítja, megilleti havi munkaidejének legalább 10 százalékos munkaidő kedvezménye', 'igen, minden esetben']
    }, {
        nr: 203,
        question: '7.21. Hol kell munkavédelmi képviselőt(ket) választani?',
        type: 'radio',
        answers: ['munkavédelmi képviselő választást kell tartani minden munkáltatónál, ahol a munkavállalók létszáma legalább 20 fő', 'munkavédelmi képviselő választást kell tartani minden munkáltatónál, ahol a munkavállalók létszáma legalább 50 fő']
    }, {
        nr: 204,
        question: '7.22. A munkavédelmi képviselőt hány évre választják?',
        type: 'radio',
        answers: ['a munkavédelmi képviselőt egyenlő, titkos és közvetlen szavazással öt évre választják', 'A munkavédelmi képviselőt egyenlő, titkos és közvetlen szavazással négy évre választják']
    }, {
        nr: 205,
        question: '7.23. Választható-e munkavédelmi képviselővé, aki munkáltatói jogot gyakorol?',
        type: 'radio',
        answers: ['igen de csak akkor,ha tagja az Üzemi Tanácsnak', 'nem választható munkavédelmi képviselővé, aki munkáltatói jogot gyakorol']
    }, {
        nr: 206,
        question: '7.24. Kötelező-e együtt tartani az Üzemi Tanácsi választásokkal a munkavédelmi képviselő választást?',
        type: 'radio',
        answers: ['nem kötelező együtt tartani a két választást', 'igen, de csak abban az esetben, ha ehhez a szakszervezet hozzájárult']
    }, {
        nr: 207,
        question: '7.25. Mikor kell létrehozni a képviselő választás esetében a Választási Bizottságot?',
        type: 'radio',
        answers: ['a Választási Bizottságnak legkésőbb a választás időpontja előtt hatvan nappal létre kell jönniük', 'a Választási Bizottságnak legkésőbb a választás időpontja előtt százhúsz nappal létre kell jönniük']
    }, {
        nr: 208,
        question: '7.26. A Választási Bizottságnak hány fő a minimális létszáma?',
        type: 'radio',
        answers: ['3 fő', '5 fő']
    }, {
        nr: 209,
        question: '7.27. Kik állíthatnak a választásra jogosult munkavállalók közül munkavédelmi képviselőjelöltet?',
        type: 'radio',
        answers: ['jelöltet állíthat a választásra jogosult munkavállalók legalább 30 százaléka', 'jelöltet állíthat a választásra jogosult munkavállalók legalább tíz százaléka, vagy ötven választásra jogosult munkavállaló, vagy a munkáltatónál képviselettel rendelkező szakszervezet']
    }, {
        nr: 210,
        question: '7.28. Hogyan történik a munkavédelmi képviselők választása?',
        type: 'radio',
        answers: ['a munkavédelmi képviselőket nyílt szavazással választják', 'a munkavédelmi képviselőket titkos és közvetlen szavazással választják']
    }, {
        nr: 211,
        question: '7.29. Ki tekinthető megválasztott munkavédelmi képviselőnek?',
        type: 'radio',
        answers: ['megválasztott munkavédelmi képviselőnek azokat kell tekinteni, akik a leadott érvényes szavazatok közül a legtöbbet, de legalább a szavazatok harminc százalékát megszerezték', 'megválasztott munkavédelmi képviselőnek azokat kell tekinteni, akik a leadott érvényes szavazatok közül a legtöbbet, de legalább a szavazatok tíz százalékát megszerezték']
    }, {
        nr: 212,
        question: '7.30. Mikor érvényes a munkavédelmi képviselő választás?',
        type: 'radio',
        answers: ['a választás akkor érvényes, ha azon a választásra jogosultak több mint fele részt vett', 'a választás akkor érvényes, ha azon a választásra jogosultak több mint kétharmada részt vett']
    }, {
        nr: 213,
        question: '8.1. Melyik szervezet látja el a munkavédelemre vonatkozó szabályok megtartásának elősegítését?',
        type: 'radio',
        answers: ['a munkavédelemre vonatkozó szabályok megtartásának elősegítését, valamint ellenőrzését a munkavédelmi hatóság látja el', 'a munkavédelemre vonatkozó szabályok megtartásának elősegítését, valamint ellenőrzését az Üzemi Tanács látja el']
    }, {
        nr: 214,
        question: '8.2. Mivel segíti a munkavédelmi hatóság a munkáltatókat és munkavállalókat, a munkavédelmi képviselőket, továbbá az érdekképviseleteket, hogy azok a munkavédelemmel kapcsolatos jogaikat gyakorolhassák, és kötelezettségeiket teljesíthessék?',
        type: 'radio',
        answers: ['helyszíni ellenőrzés fokozásával', 'tájékoztatással és tanácsadással']
    }, {
        nr: 215,
        question: '8.3. Melyik szervezetek hozták létre és üzemeltetik a munkavédelmi információs rendszert (továbbiakban: MIR)?',
        type: 'radio',
        answers: ['a MIR szolgáltatásait a foglalkoztatáspolitikáért felelős miniszter és a Magyar Bányászati és Földtani Szolgálat szervezeti keretében önállóan létrehozott, de a hatósági tevékenységtől elkülönülő munkavédelmi információs és tanácsadó szolgálatok végzik', 'a MIR-t a Szakszervezeti Konföderációk közösen hozták létre és üzemeltetik']
    }, {
        nr: 216,
        question: '8.4. Az Országos Munkavédelmi Bizottság segíti a MIR működését?',
        type: 'radio',
        answers: ['az Országos Munkavédelmi Bizottság saját adataival, megállapításaival segíti a MIR működését', 'nem, mert ez nem a Bizottság feladata']
    }, {
        nr: 217,
        question: '8.5. A MIR által nyújtott tájékoztatás tartalmazhat konkrét műszaki megoldást, tervet, illetve végrehajtási javaslatot?',
        type: 'radio',
        answers: ['tartalmazhat műszaki megoldást.', 'a MIR által nyújtott tájékoztatás kizárólag a munkavédelemre vonatkozó szabályokban megfogalmazott normatív követelmények ismertetését tartalmazhatja']
    }, {
        nr: 218,
        question: '8.6. Ki biztosítja a MIR zavartalan működéséhez szükséges személyi és tárgyi feltételeket?',
        type: 'radio',
        answers: ['a MIR szolgálatot működtetett miniszter gondoskodik a szolgálat adott hatóságnál működő rendszerének kialakításáról, személyi és tárgyi feltételeinek biztosításáról és folyamatos működtetéséről', 'a MIR működtetéséről az Országos Munkavédelmi Bizottság gondoskodik']
    }, {
        nr: 219,
        question: '8.7. Mikor és hogyan érhető el a MIR információ szerzés céljából?',
        type: 'radio',
        answers: ['a MIR szolgálat munkanapokon, hivatali időben telefonon, személyesen, illetőleg írásban nyújt információt', 'a szolgálat munkanapokon csak személyesen érhető el']
    }, {
        nr: 220,
        question: '8.8. A MIR által nyújtott információs szolgáltatás igénybevétele mentesíti-e teljes egészében a munkáltatót a munkavédelmi kötelezettségek és követelmények teljesítése alól?',
        type: 'radio',
        answers: ['a Szolgálat által nyújtott információs szolgáltatás igénybevétele nem mentesíti a munkáltatót a munkavédelmi kötelezettségek és követelmények - különösen a munkavállalók irányában fennálló tájékoztatási kötelezettségek - teljesítése alól', 'a szolgálat által nyújtott információs szolgáltatás igénybevétele súlyos veszélyeztetés fennállása esetén, mentesíti a munkáltatót a munkavédelmi kötelezettségek és követelmények teljesítése alól']
    }, {
        nr: 221,
        question: '8.9. Kell-e biztosítani az információszolgáltatás során, hogy az igénybe vevő személyek és szervezetek névtelenségüket megőrizve jussanak hozzá a kért tájékoztatáshoz?',
        type: 'radio',
        answers: ['igen, minden esetben', 'igen, de csak abban az esetben, ha a tájékoztatás személyes jellegű']
    }, {
        nr: 222,
        question: '8.10. A munkavédelmi hatóság ellenőrizheti-e a foglalkozás-egészségügyi szolgálatok munkavédelmi feladatainak megvalósítását is?',
        type: 'radio',
        answers: ['a foglalkozás-egészségügyi szolgálatok munkavédelmi feladatainak megvalósítását a Nemzeti Népegészségügyi Központ ellenőrzi', 'a munkavédelmi hatóság ellenőrzése kiterjed a munkáltatók és munkavállalók egészséget nem veszélyeztető és biztonságos munkavégzéssel kapcsolatos feladatainak és kötelezettségeinek teljesítésére, ideértve a foglalkozás-egészségügyi szolgálatok munkavédelmi feladatainak megvalósítását']
    }, {
        nr: 223,
        question: '8.11. Jogosult-e ellenőrizni a munkavédelmi hatóság az egyéni védőeszközökre vonatkozó követelmények érvényesítését?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság csak panasz esetén jogosult ellenőrizni az egyéni védőeszközöket', 'a munkavédelmi hatóság ellenőrzése kiterjed a munkahelyek létesítésére, a munkaeszközök üzemeltetésére, az alkalmazott technológiákra és anyagokra, valamint az egyéni védőeszközökre vonatkozó követelmények érvényesítésére']
    }, {
        nr: 224,
        question: '8.12. A munkavédelmi hatóság tarthat-e hatósági ellenőrzést a munkabalesetek, foglalkozási megbetegedések és fokozott expozíciós esetek kivizsgálásával, bejelentésével, nyilvántartásával kapcsolatosan?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság ellenőrzése kiterjed a munkabalesetek, foglalkozási megbetegedések és fokozott expozíciós esetek kivizsgálására, bejelentésére, nyilvántartására, valamint megelőzésére tett intézkedésekre', 'a munkavédelmi hatóság ellenőrzése nem terjed ki a foglalkozási megbetegedések kivizsgálására']
    }, {
        nr: 225,
        question: '8.13. Minek alapján végez ellenőrzéseket a munkavédelmi hatóság?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság az ellenőrzési tevékenységét a foglalkoztatáspolitikáért felelős miniszter által közzétett ellenőrzési irányelv alapján végzi', 'a munkavédelmi hatóság elsősorban saját maga által elkészített ellenőrzési irányelvek alapján végez ellenőrzést']
    }, {
        nr: 226,
        question: '8.14. A munkavédelmi hatóság köteles-e kivizsgálni a hozzá beérkező panaszokat és közérdekű bejelentéseket?',
        type: 'radio',
        answers: ['a panaszokról és a közérdekű bejelentésekről szóló 2013. évi CLXV. törvény 1. § (1) bekezdése értelmében a munkavédelmi hatóság a hozzá beérkező panaszokat és közérdekű bejelentéseket köteles kivizsgálni', 'a hatóság csak azokat a bejelentéseket köteles kivizsgálni, amelyeket írásban tesz meg a bejelentő']
    }, {
        nr: 227,
        question: '8.15. Kiszabható-e eljárási bírság, amennyiben a munkáltató határozatban foglalt kötelezettségek teljesítését elmulasztja?',
        type: 'radio',
        answers: ['a határozatban foglalt kötelezettségek teljesítését elmulasztó munkáltatókat a hatóság indokolt esetben eljárási bírsággal sújtja', 'abban az esetben, ha a mulasztás közvetlen életveszélyes állapotot teremt']
    }, {
        nr: 228,
        question: '8.16. Az audit jellegű átfogó vizsgálat alkalmazásakor a munkavédelmi hatóság értesíti-e a munkáltatót a tervezett ellenőrzés előtt, a helyszíni ellenőrzés időpontjáról?',
        type: 'radio',
        answers: ['a hatóság az audit jellegű átfogó vizsgálat alkalmazásakor nem küld előzetes értesítést', 'az audit jellegű átfogó vizsgálat alkalmazásakor a munkavédelmi hatóság egy hónappal a tervezett ellenőrzés előtt értesíti a munkáltatót a helyszíni ellenőrzésről, annak pontos időpontja megjelölésével, valamint az előkészítendő és ellenőrzésre kerülő dokumentációk felsorolásával']
    }, {
        nr: 229,
        question: '8.17. A munkavédelmi szakemberek függő helyzetben vannak a munkáltatóval, szemben és így gyakran nem a jogszabályoknak történő megfelelés, hanem a munkáltató gazdasági érdekei élveznek prioritást?',
        type: 'radio',
        answers: ['a hatósági ellenőrzések alkalmából tapasztaltak a felügyelők ilyen eseteket', 'nincs ilyen tapasztalat, mivel a munkavédelmi szakemberek munkajogi védettséget élveznek']
    }, {
        nr: 230,
        question: '8.18. Alkalmazhat-e a hatóság munkavédelmi bírságot, az egészséget nem veszélyeztető és biztonságos munkavégzésre vonatkozó követelmények teljesítését elmulasztó, és ezzel a munkavállaló életét, testi épségét vagy egészségét súlyosan veszélyeztető munkáltatóval szemben?',
        type: 'radio',
        answers: ['a hatóság csak figyelmeztetésben részesíti a munkáltatót', 'a munkavédelmi hatóság munkavédelmi bírságot alkalmaz az egészséget nem veszélyeztető és biztonságos munkavégzésre vonatkozó követelmények teljesítését elmulasztó, és ezzel a munkavállaló életét, testi épségét vagy egészségét súlyosan veszélyeztető munkáltatóval szemben']
    }, {
        nr: 231,
        question: '8.19. Mekkora lehet a munkavédelmi bírság összege?',
        type: 'radio',
        answers: ['a munkavédelmi bírság összege 50 000 Ft-tól 10 000 000 Ft-ig terjedhet', 'a munkavédelmi bírság összege 50 000 Ft-tól 500 000 Ft-ig terjedhet']
    }, {
        nr: 232,
        question: '8.20. A munkavédelmi hatóság közigazgatási bírságot természetes személyre, vagy vállalatra, intézményre szabhat-e ki?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság közigazgatási bírsággal csak a természetes személyt sújtja', 'a munkavédelmi hatóság közigazgatási bírságot - indokolt esetben - a vállalat, illetve intézmény esetében is alkalmazhat']
    }, {
        nr: 233,
        question: '8.21. Kiszabható-e közigazgatási bírság arra a munkavállalóra, aki a munkáltató képviselőjeként a munkavédelmi képviselő választásra vonatkozó szabályokat megszegi?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság közigazgatási bírsággal sújtja azt a természetes személyt, aki a munkáltató képviselőjeként a munkavédelmi képviselő választásra vonatkozó szabályokat megszegi', 'nem, mert nem minősül súlyos szabályszegésnek, ha munkáltató a munkavédelmi képviselő választásra vonatkozó szabályokat megszegi']
    }, {
        nr: 234,
        question: '8.22. Mekkora lehet a kiszabott közigazgatási bírság összege?',
        type: 'radio',
        answers: ['a közigazgatási bírság keretében kiszabott bírság összege maximum 500 000 Ft lehet', 'a közigazgatási bírság keretében kiszabott bírság összege maximum 100 000 Ft lehet']
    }, {
        nr: 235,
        question: '8.23. A munkavédelmi képviselő (bizottság) jogosult szakértőt igénybe venni az egészséget nem veszélyeztető és biztonságos munkavégzéssel összefüggő kérdésekben?',
        type: 'radio',
        answers: ['minden esetben', 'igen, de csak akkor, ha a munkáltatóval ebben előzetes megállapodott']
    }, {
        nr: 236,
        question: '8.24. Szükséges-e a munkáltató engedélye, ha a munkavédelmi képviselő a hatósághoz akar fordulni?',
        type: 'radio',
        answers: ['a munkavédelmi képviselő (bizottság) jogosult az egészséget nem veszélyeztető és biztonságos munkavégzéssel összefüggő kérdésekben megbeszélést folytatni a munkavédelmi hatósággal', 'igen, de csak akkor, ha ehhez előzetesen engedélyt kért a Munkavédelmi Bizottságtól']
    }, {
        nr: 237,
        question: '8.25. Jogosult-e a hatóság nyilvántartást vezetni a rákkeltő anyagok okozta foglalkozási eredetű egészségkárosodásokról, illetve daganatos megbetegedésekről?',
        type: 'radio',
        answers: ['nem, mert ez bizalmas adatnak minősül', 'a munkavédelmi hatóság nyilvántartást vezet annak érdekében, hogy a kockázatok minimálisra csökkentésével elősegítse a munkavállalók védelmét a rákkeltő anyagok okozta foglalkozási eredetű egészségkárosodásokkal, illetve daganatos megbetegedésekkel szemben']
    }, {
        nr: 238,
        question: '8.26. A munkavállalók, illetve a munkavédelmi képviselő kaphatnak-e felvilágosítást a munkakörülményekkel kapcsolatban a foglalkozás-egészségügyi szolgálattól?',
        type: 'radio',
        answers: ['a munkáltatónak biztosítania kell, hogy munkavállalói és azok munkavédelmi képviselői a munkakörülményeikkel kapcsolatban, a szükséges felvilágosítást a foglalkozás-egészségügyi szolgálattól megkaphassák', 'nem, mert ezek az adatok sértenék a személyiségi jogokat']
    }, {
        nr: 239,
        question: '8.27. Mennyi a munkavédelmi hatósági ellenőrzés határideje a baleset, munkabalesetté való minősítésével kapcsolatban?',
        type: 'radio',
        answers: ['90 nap', '45 nap']
    }, {
        nr: 240,
        question: '8.28. Jogosult-e a munkavédelmi hatóság a közúti közlekedéssel kapcsolatos munkabaleseteket kivizsgálni?',
        type: 'radio',
        answers: ['igen, de csak akkor, ha a baleset munkaidőben történt', 'a munkavédelmi hatóság jogosult a munkabaleseteket - kivéve a közúti közlekedéssel kapcsolatosakat - és a fokozott expozíciós eseteket - a munkáltató ez irányú felelősségét nem érintve - kivizsgálni']
    }, {
        nr: 241,
        question: '8.29. A munkavédelmi hatóság jogosult-e felülbírálni a munkabaleset minősítését a munkáltatóval szemben?',
        type: 'radio',
        answers: ['a hatóság jogosult a balesetet munkabalesetnek minősíteni', 'igen, de csak akkor, ha ehhez a munkáltató és az Üzemi Tanács is hozzájárult']
    }, {
        nr: 242,
        question: '8.30. Megfellebbezhető-e a munkavédelmi hatóság által hozott elsőfokú döntés?',
        type: 'radio',
        answers: ['a munkavédelmi hatóság által hozott elsőfokú döntéssel szemben nincs helye fellebbezésnek', 'igen, de csak akkor, ha ehhez a munkáltató is hozzájárult']
    },
];